/* tslint:disable */
/* eslint-disable */
/**
 * Agent Management API
 * CRUD for agents
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Message from the AI model.
 * @export
 * @interface AIMessage
 */
export interface AIMessage {
    /**
     * 
     * @type {string}
     * @memberof AIMessage
     */
    'type'?: AIMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AIMessage
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<AIMessageContentBlocksInner>}
     * @memberof AIMessage
     */
    'content_blocks'?: Array<AIMessageContentBlocksInner>;
    /**
     * 
     * @type {number}
     * @memberof AIMessage
     */
    'token_count': number;
}

export const AIMessageTypeEnum = {
    AI: 'ai'
} as const;

export type AIMessageTypeEnum = typeof AIMessageTypeEnum[keyof typeof AIMessageTypeEnum];

/**
 * @type AIMessageContentBlocksInner
 * @export
 */
export type AIMessageContentBlocksInner = { type: 'text' } & TextContentBlock | { type: 'tool_call' } & ToolCallContentBlock;

/**
 * Agent metadata without versions.
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'id': string;
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof Agent
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'description': string;
    /**
     * 
     * @type {AgentMetadata}
     * @memberof Agent
     */
    'metadata': AgentMetadata;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'folder_id'?: string | null;
    /**
     * 
     * @type {PrebuiltConfiguration}
     * @memberof Agent
     */
    'prebuilt_configuration'?: PrebuiltConfiguration | null;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'published_versions_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'draft_versions_count'?: number;
}
/**
 * Request schema for agent invocation from the analytics frontend.
 * @export
 * @interface AgentAnalyticsInvokeRequest
 */
export interface AgentAnalyticsInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'type'?: AgentAnalyticsInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'source'?: AgentAnalyticsInvokeRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentAnalyticsInvokeRequest
     */
    'client_timezone'?: string | null;
}

export const AgentAnalyticsInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentAnalyticsInvokeRequestTypeEnum = typeof AgentAnalyticsInvokeRequestTypeEnum[keyof typeof AgentAnalyticsInvokeRequestTypeEnum];
export const AgentAnalyticsInvokeRequestSourceEnum = {
    ANALYTICS: 'analytics'
} as const;

export type AgentAnalyticsInvokeRequestSourceEnum = typeof AgentAnalyticsInvokeRequestSourceEnum[keyof typeof AgentAnalyticsInvokeRequestSourceEnum];

/**
 * Request schema for agent invocation from a case.
 * @export
 * @interface AgentCaseInvokeRequest
 */
export interface AgentCaseInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentCaseInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentCaseInvokeRequest
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentCaseInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentCaseInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'type'?: AgentCaseInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'source'?: AgentCaseInvokeRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentCaseInvokeRequest
     */
    'case_id': string;
}

export const AgentCaseInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentCaseInvokeRequestTypeEnum = typeof AgentCaseInvokeRequestTypeEnum[keyof typeof AgentCaseInvokeRequestTypeEnum];
export const AgentCaseInvokeRequestSourceEnum = {
    CASE: 'case'
} as const;

export type AgentCaseInvokeRequestSourceEnum = typeof AgentCaseInvokeRequestSourceEnum[keyof typeof AgentCaseInvokeRequestSourceEnum];

/**
 * 
 * @export
 * @interface AgentCreate
 */
export interface AgentCreate {
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof AgentCreate
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'folder_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentCreateResponse
 */
export interface AgentCreateResponse {
    /**
     * 
     * @type {Agent}
     * @memberof AgentCreateResponse
     */
    'agent': Agent;
}
/**
 * Request schema for direct agent API invocation.  Used by external API consumers (e.g., public API, direct client calls). Does not include flow-specific context.
 * @export
 * @interface AgentDirectInvokeRequest
 */
export interface AgentDirectInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentDirectInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentDirectInvokeRequest
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentDirectInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentDirectInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'type'?: AgentDirectInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'source'?: AgentDirectInvokeRequestSourceEnum;
}

export const AgentDirectInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentDirectInvokeRequestTypeEnum = typeof AgentDirectInvokeRequestTypeEnum[keyof typeof AgentDirectInvokeRequestTypeEnum];
export const AgentDirectInvokeRequestSourceEnum = {
    API: 'api'
} as const;

export type AgentDirectInvokeRequestSourceEnum = typeof AgentDirectInvokeRequestSourceEnum[keyof typeof AgentDirectInvokeRequestSourceEnum];

/**
 * Request schema for agent invocation from within a flow.  Used by runner when executing agent delegation nodes. Includes additional context about the flow execution environment.
 * @export
 * @interface AgentFlowInvokeRequest
 */
export interface AgentFlowInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentFlowInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentFlowInvokeRequest
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentFlowInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentFlowInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'type'?: AgentFlowInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'source'?: AgentFlowInvokeRequestSourceEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof AgentFlowInvokeRequest
     */
    'flow_context': FlowRuntimeContext;
}

export const AgentFlowInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentFlowInvokeRequestTypeEnum = typeof AgentFlowInvokeRequestTypeEnum[keyof typeof AgentFlowInvokeRequestTypeEnum];
export const AgentFlowInvokeRequestSourceEnum = {
    FLOW: 'flow'
} as const;

export type AgentFlowInvokeRequestSourceEnum = typeof AgentFlowInvokeRequestSourceEnum[keyof typeof AgentFlowInvokeRequestSourceEnum];

/**
 * 
 * @export
 * @interface AgentGetResponse
 */
export interface AgentGetResponse {
    /**
     * 
     * @type {AgentWithLastPublished}
     * @memberof AgentGetResponse
     */
    'agent': AgentWithLastPublished;
}
/**
 * Aggregate metrics computed over all filtered sessions (before pagination).
 * @export
 * @interface AgentHistoryAggregateMetrics
 */
export interface AgentHistoryAggregateMetrics {
    /**
     * 
     * @type {number}
     * @memberof AgentHistoryAggregateMetrics
     */
    'avg_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentHistoryAggregateMetrics
     */
    'avg_duration_ms'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentHistoryAggregateMetrics
     */
    'avg_cost_usd'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentHistoryAggregateMetrics
     */
    'avg_error_rate_percentage'?: number;
}
/**
 * 
 * @export
 * @interface AgentHistoryResponse
 */
export interface AgentHistoryResponse {
    /**
     * 
     * @type {Array<SessionListItem>}
     * @memberof AgentHistoryResponse
     */
    'sessions': Array<SessionListItem>;
    /**
     * 
     * @type {AgentHistoryAggregateMetrics}
     * @memberof AgentHistoryResponse
     */
    'metrics': AgentHistoryAggregateMetrics;
    /**
     * 
     * @type {number}
     * @memberof AgentHistoryResponse
     */
    'total_count': number;
    /**
     * 
     * @type {string}
     * @memberof AgentHistoryResponse
     */
    'next_cursor'?: string | null;
}
/**
 * Response from agent invocation. Returns the agent\'s message output regardless of invocation method.
 * @export
 * @interface AgentInvokeResponse
 */
export interface AgentInvokeResponse {
    /**
     * 
     * @type {string}
     * @memberof AgentInvokeResponse
     */
    'session_id': string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof AgentInvokeResponse
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof AgentInvokeResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentInvokeResponse
     */
    'structured_output'?: { [key: string]: any; } | null;
}


/**
 * 
 * @export
 * @interface AgentListResponse
 */
export interface AgentListResponse {
    /**
     * 
     * @type {Array<Agent>}
     * @memberof AgentListResponse
     */
    'agents': Array<Agent>;
}
/**
 * Metadata for Agent.
 * @export
 * @interface AgentMetadata
 */
export interface AgentMetadata {
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'updated_by_id': string;
}
/**
 * Information about a model available for agents.
 * @export
 * @interface AgentModelInfo
 */
export interface AgentModelInfo {
    /**
     * Model identifier
     * @type {Model}
     * @memberof AgentModelInfo
     */
    'model_id': Model;
    /**
     * Human-readable model name
     * @type {string}
     * @memberof AgentModelInfo
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModelInfo
     */
    'description'?: string | null;
    /**
     * Model provider
     * @type {ModelProvider}
     * @memberof AgentModelInfo
     */
    'provider': ModelProvider;
    /**
     * Whether model is in preview by the provider
     * @type {boolean}
     * @memberof AgentModelInfo
     */
    'is_preview'?: boolean;
    /**
     * Model lifecycle status
     * @type {string}
     * @memberof AgentModelInfo
     */
    'status'?: AgentModelInfoStatusEnum;
    /**
     * 
     * @type {Model}
     * @memberof AgentModelInfo
     */
    'deprecated_alternative'?: Model | null;
    /**
     * 
     * @type {string}
     * @memberof AgentModelInfo
     */
    'routing_target_region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentModelInfo
     */
    'credential_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentModelInfo
     */
    'credential_name'?: string | null;
    /**
     * Reasoning levels this model supports
     * @type {Array<ReasoningLevel>}
     * @memberof AgentModelInfo
     */
    'supported_reasoning_levels': Array<ReasoningLevel>;
    /**
     * Maximum context window in tokens
     * @type {number}
     * @memberof AgentModelInfo
     */
    'context_window_size': number;
    /**
     * 
     * @type {number}
     * @memberof AgentModelInfo
     */
    'input_cost_per_1m_tokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentModelInfo
     */
    'output_cost_per_1m_tokens'?: number | null;
    /**
     * Comparative intelligence indicator
     * @type {number}
     * @memberof AgentModelInfo
     */
    'intelligence': number;
    /**
     * Comparative speed indicator
     * @type {number}
     * @memberof AgentModelInfo
     */
    'speed': number;
    /**
     * Model release date
     * @type {string}
     * @memberof AgentModelInfo
     */
    'release_date': string;
    /**
     * 
     * @type {Model}
     * @memberof AgentModelInfo
     */
    'superseded_by'?: Model | null;
}

export const AgentModelInfoStatusEnum = {
    ACTIVE: 'active',
    WIP: 'wip',
    DEPRECATED: 'deprecated'
} as const;

export type AgentModelInfoStatusEnum = typeof AgentModelInfoStatusEnum[keyof typeof AgentModelInfoStatusEnum];

/**
 * Request schema for playground agent invocation.  Playground invocations use a shared AgentCore runtimeSessionId for pre-warming, while maintaining separate application-level sessions.
 * @export
 * @interface AgentPlaygroundInvokeRequest
 */
export interface AgentPlaygroundInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'type'?: AgentPlaygroundInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'source'?: AgentPlaygroundInvokeRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'playground_id': string;
}

export const AgentPlaygroundInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentPlaygroundInvokeRequestTypeEnum = typeof AgentPlaygroundInvokeRequestTypeEnum[keyof typeof AgentPlaygroundInvokeRequestTypeEnum];
export const AgentPlaygroundInvokeRequestSourceEnum = {
    PLAYGROUND: 'playground'
} as const;

export type AgentPlaygroundInvokeRequestSourceEnum = typeof AgentPlaygroundInvokeRequestSourceEnum[keyof typeof AgentPlaygroundInvokeRequestSourceEnum];

/**
 * 
 * @export
 * @interface AgentPrebuiltConfigurationPatch
 */
export interface AgentPrebuiltConfigurationPatch {
    /**
     * 
     * @type {PrebuiltConfiguration}
     * @memberof AgentPrebuiltConfigurationPatch
     */
    'prebuilt_configuration'?: PrebuiltConfiguration | null;
}
/**
 * 
 * @export
 * @interface AgentUpdate
 */
export interface AgentUpdate {
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'folder_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentUpdateResponse
 */
export interface AgentUpdateResponse {
    /**
     * 
     * @type {Agent}
     * @memberof AgentUpdateResponse
     */
    'agent': Agent;
}
/**
 * Agent version summary without full configuration.
 * @export
 * @interface AgentVersion
 */
export interface AgentVersion {
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'id': string;
    /**
     * Optimistic locking version tag
     * @type {string}
     * @memberof AgentVersion
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'description': string;
    /**
     * Reference to parent Agent
     * @type {string}
     * @memberof AgentVersion
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentVersion
     */
    'status': AgentVersionStatus;
    /**
     * 
     * @type {AgentVersionMetadata}
     * @memberof AgentVersion
     */
    'metadata': AgentVersionMetadata;
    /**
     * 
     * @type {AgentVersionConfigurationOutput}
     * @memberof AgentVersion
     */
    'configuration': AgentVersionConfigurationOutput;
}


/**
 * Agent version configuration.
 * @export
 * @interface AgentVersionConfigurationInput
 */
export interface AgentVersionConfigurationInput {
    /**
     * 
     * @type {AgentVersionLLMConfig}
     * @memberof AgentVersionConfigurationInput
     */
    'model_config': AgentVersionLLMConfig;
    /**
     * 
     * @type {Array<AgentVersionConfigurationInputToolsInner>}
     * @memberof AgentVersionConfigurationInput
     */
    'tools'?: Array<AgentVersionConfigurationInputToolsInner>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInput
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInput
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * Execution configuration for runtime limits and behavior
     * @type {ExecutionConfig}
     * @memberof AgentVersionConfigurationInput
     */
    'execution_config'?: ExecutionConfig;
    /**
     * Experimental configuration for preview features.  All fields are optional - if not provided, defaults are used at runtime.  NOTE: features might be removed or changed without notice.
     * @type {object}
     * @memberof AgentVersionConfigurationInput
     */
    'experimental'?: object;
    /**
     * 
     * @type {Array<CustomizationCategory>}
     * @memberof AgentVersionConfigurationInput
     */
    'customizations_display'?: Array<CustomizationCategory> | null;
}
/**
 * 
 * @export
 * @interface AgentVersionConfigurationInputToolsInner
 */
export interface AgentVersionConfigurationInputToolsInner {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'type'?: AgentVersionConfigurationInputToolsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_type'?: AgentVersionConfigurationInputToolsInnerOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'input_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'data_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'chart_format'?: AgentVersionConfigurationInputToolsInnerChartFormatEnum;
    /**
     * 
     * @type {Array<SpecialDomain>}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'special_domains'?: Array<SpecialDomain>;
}

export const AgentVersionConfigurationInputToolsInnerTypeEnum = {
    FLOW: 'flow',
    READ_FILE: 'read_file',
    CALCULATOR: 'calculator',
    WEB_SEARCH: 'web_search',
    GET_CASE_BY_ID: 'get_case_by_id',
    GET_CASE_HINTS: 'get_case_hints',
    GET_CASE_HISTORY: 'get_case_history',
    GET_ENTITY_BY_ID: 'get_entity_by_id',
    GET_RELATED_ENTITIES: 'get_related_entities',
    LIST_CASES: 'list_cases',
    PATCH_CASE_TASK_HINT: 'patch_case_task_hint',
    PATCH_CASE_ACTION_HINT: 'patch_case_action_hint',
    PATCH_HINTED_NEXT_ACTION: 'patch_hinted_next_action',
    GET_EVENT_BY_ID: 'get_event_by_id',
    QUERY_EVENTS: 'query_events',
    LIST_ENTITY_TYPE_SCHEMAS: 'list_entity_type_schemas',
    LIST_EVENT_TYPE_SCHEMAS: 'list_event_type_schemas',
    QUERY_METRICS: 'query_metrics',
    REPLY_VISUALIZE_METRICS: 'reply_visualize_metrics'
} as const;

export type AgentVersionConfigurationInputToolsInnerTypeEnum = typeof AgentVersionConfigurationInputToolsInnerTypeEnum[keyof typeof AgentVersionConfigurationInputToolsInnerTypeEnum];
export const AgentVersionConfigurationInputToolsInnerOutputTypeEnum = {
    STRING: 'string'
} as const;

export type AgentVersionConfigurationInputToolsInnerOutputTypeEnum = typeof AgentVersionConfigurationInputToolsInnerOutputTypeEnum[keyof typeof AgentVersionConfigurationInputToolsInnerOutputTypeEnum];
export const AgentVersionConfigurationInputToolsInnerChartFormatEnum = {
    VEGA: 'vega'
} as const;

export type AgentVersionConfigurationInputToolsInnerChartFormatEnum = typeof AgentVersionConfigurationInputToolsInnerChartFormatEnum[keyof typeof AgentVersionConfigurationInputToolsInnerChartFormatEnum];

/**
 * Agent version configuration.
 * @export
 * @interface AgentVersionConfigurationOutput
 */
export interface AgentVersionConfigurationOutput {
    /**
     * 
     * @type {AgentVersionLLMConfig}
     * @memberof AgentVersionConfigurationOutput
     */
    'model_config': AgentVersionLLMConfig;
    /**
     * 
     * @type {Array<AgentVersionConfigurationOutputToolsInner>}
     * @memberof AgentVersionConfigurationOutput
     */
    'tools'?: Array<AgentVersionConfigurationOutputToolsInner>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutput
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutput
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * Execution configuration for runtime limits and behavior
     * @type {ExecutionConfig}
     * @memberof AgentVersionConfigurationOutput
     */
    'execution_config'?: ExecutionConfig;
    /**
     * Experimental configuration for preview features.  All fields are optional - if not provided, defaults are used at runtime.  NOTE: features might be removed or changed without notice.
     * @type {object}
     * @memberof AgentVersionConfigurationOutput
     */
    'experimental'?: object;
    /**
     * 
     * @type {Array<CustomizationCategory>}
     * @memberof AgentVersionConfigurationOutput
     */
    'customizations_display'?: Array<CustomizationCategory> | null;
}
/**
 * 
 * @export
 * @interface AgentVersionConfigurationOutputToolsInner
 */
export interface AgentVersionConfigurationOutputToolsInner {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'type'?: AgentVersionConfigurationOutputToolsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_type'?: AgentVersionConfigurationOutputToolsInnerOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'input_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'data_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'chart_format'?: AgentVersionConfigurationOutputToolsInnerChartFormatEnum;
    /**
     * 
     * @type {Array<SpecialDomain>}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'special_domains'?: Array<SpecialDomain>;
}

export const AgentVersionConfigurationOutputToolsInnerTypeEnum = {
    FLOW: 'flow',
    READ_FILE: 'read_file',
    CALCULATOR: 'calculator',
    WEB_SEARCH: 'web_search',
    GET_CASE_BY_ID: 'get_case_by_id',
    GET_CASE_HINTS: 'get_case_hints',
    GET_CASE_HISTORY: 'get_case_history',
    GET_ENTITY_BY_ID: 'get_entity_by_id',
    GET_RELATED_ENTITIES: 'get_related_entities',
    LIST_CASES: 'list_cases',
    PATCH_CASE_TASK_HINT: 'patch_case_task_hint',
    PATCH_CASE_ACTION_HINT: 'patch_case_action_hint',
    PATCH_HINTED_NEXT_ACTION: 'patch_hinted_next_action',
    GET_EVENT_BY_ID: 'get_event_by_id',
    QUERY_EVENTS: 'query_events',
    LIST_ENTITY_TYPE_SCHEMAS: 'list_entity_type_schemas',
    LIST_EVENT_TYPE_SCHEMAS: 'list_event_type_schemas',
    QUERY_METRICS: 'query_metrics',
    REPLY_VISUALIZE_METRICS: 'reply_visualize_metrics'
} as const;

export type AgentVersionConfigurationOutputToolsInnerTypeEnum = typeof AgentVersionConfigurationOutputToolsInnerTypeEnum[keyof typeof AgentVersionConfigurationOutputToolsInnerTypeEnum];
export const AgentVersionConfigurationOutputToolsInnerOutputTypeEnum = {
    STRING: 'string'
} as const;

export type AgentVersionConfigurationOutputToolsInnerOutputTypeEnum = typeof AgentVersionConfigurationOutputToolsInnerOutputTypeEnum[keyof typeof AgentVersionConfigurationOutputToolsInnerOutputTypeEnum];
export const AgentVersionConfigurationOutputToolsInnerChartFormatEnum = {
    VEGA: 'vega'
} as const;

export type AgentVersionConfigurationOutputToolsInnerChartFormatEnum = typeof AgentVersionConfigurationOutputToolsInnerChartFormatEnum[keyof typeof AgentVersionConfigurationOutputToolsInnerChartFormatEnum];

/**
 * 
 * @export
 * @interface AgentVersionCreate
 */
export interface AgentVersionCreate {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'description': string;
    /**
     * 
     * @type {AgentVersionConfigurationInput}
     * @memberof AgentVersionCreate
     */
    'configuration'?: AgentVersionConfigurationInput | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'source_version_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentVersionId
 */
export interface AgentVersionId {
}
/**
 * LLM configuration.
 * @export
 * @interface AgentVersionLLMConfig
 */
export interface AgentVersionLLMConfig {
    /**
     * Model identifier
     * @type {Model}
     * @memberof AgentVersionLLMConfig
     */
    'model': Model;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionLLMConfig
     */
    'credential_id'?: string | null;
    /**
     * System prompt for the model
     * @type {string}
     * @memberof AgentVersionLLMConfig
     */
    'system_prompt': string;
    /**
     * Sampling temperature for the model
     * @type {number}
     * @memberof AgentVersionLLMConfig
     */
    'temperature': number;
    /**
     * 
     * @type {ReasoningLevel}
     * @memberof AgentVersionLLMConfig
     */
    'reasoning_level'?: ReasoningLevel | null;
}


/**
 * 
 * @export
 * @interface AgentVersionListResponse
 */
export interface AgentVersionListResponse {
    /**
     * 
     * @type {Array<AgentVersion>}
     * @memberof AgentVersionListResponse
     */
    'versions': Array<AgentVersion>;
}
/**
 * Metadata for AgentVersion.
 * @export
 * @interface AgentVersionMetadata
 */
export interface AgentVersionMetadata {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'updated_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'published_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'published_by_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentVersionResponse
 */
export interface AgentVersionResponse {
    /**
     * 
     * @type {AgentVersion}
     * @memberof AgentVersionResponse
     */
    'agent_version': AgentVersion;
}
/**
 * Status of an agent version.
 * @export
 * @enum {string}
 */

export const AgentVersionStatus = {
    PUBLISHED: 'published',
    DRAFT: 'draft',
    ARCHIVED: 'archived'
} as const;

export type AgentVersionStatus = typeof AgentVersionStatus[keyof typeof AgentVersionStatus];


/**
 * 
 * @export
 * @interface AgentVersionUpdate
 */
export interface AgentVersionUpdate {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionUpdate
     */
    'description': string;
    /**
     * 
     * @type {AgentVersionConfigurationInput}
     * @memberof AgentVersionUpdate
     */
    'configuration': AgentVersionConfigurationInput;
}
/**
 * 
 * @export
 * @interface AgentVersionsDependingOnFlowResponse
 */
export interface AgentVersionsDependingOnFlowResponse {
    /**
     * 
     * @type {Array<AgentVersionsDependingOnFlowResponseItem>}
     * @memberof AgentVersionsDependingOnFlowResponse
     */
    'agent_versions': Array<AgentVersionsDependingOnFlowResponseItem>;
}
/**
 * Item in AgentVersionsDependingOnFlowResponse
 * @export
 * @interface AgentVersionsDependingOnFlowResponseItem
 */
export interface AgentVersionsDependingOnFlowResponseItem {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'agent_slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'agent_name': string;
    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'status': AgentVersionStatus;
    /**
     * 
     * @type {AgentVersionMetadata}
     * @memberof AgentVersionsDependingOnFlowResponseItem
     */
    'metadata': AgentVersionMetadata;
}


/**
 * Agent with optional last published version ID.  Used as the return type for get_agent to include the latest published version.
 * @export
 * @interface AgentWithLastPublished
 */
export interface AgentWithLastPublished {
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'id': string;
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'description': string;
    /**
     * 
     * @type {AgentMetadata}
     * @memberof AgentWithLastPublished
     */
    'metadata': AgentMetadata;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'folder_id'?: string | null;
    /**
     * 
     * @type {PrebuiltConfiguration}
     * @memberof AgentWithLastPublished
     */
    'prebuilt_configuration'?: PrebuiltConfiguration | null;
    /**
     * 
     * @type {number}
     * @memberof AgentWithLastPublished
     */
    'published_versions_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentWithLastPublished
     */
    'draft_versions_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'latest_published_version_id'?: string | null;
}
/**
 * When invoked from the analytics frontend.
 * @export
 * @interface AnalyticsSourceContext
 */
export interface AnalyticsSourceContext {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsSourceContext
     */
    'source_type'?: AnalyticsSourceContextSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsSourceContext
     */
    'client_timezone'?: string | null;
}

export const AnalyticsSourceContextSourceTypeEnum = {
    ANALYTICS: 'analytics'
} as const;

export type AnalyticsSourceContextSourceTypeEnum = typeof AnalyticsSourceContextSourceTypeEnum[keyof typeof AnalyticsSourceContextSourceTypeEnum];

/**
 * When invoked from an API call.
 * @export
 * @interface ApiSourceContext
 */
export interface ApiSourceContext {
    /**
     * 
     * @type {string}
     * @memberof ApiSourceContext
     */
    'source_type'?: ApiSourceContextSourceTypeEnum;
}

export const ApiSourceContextSourceTypeEnum = {
    API: 'api'
} as const;

export type ApiSourceContextSourceTypeEnum = typeof ApiSourceContextSourceTypeEnum[keyof typeof ApiSourceContextSourceTypeEnum];

/**
 * 
 * @export
 * @interface AvailableModelsResponse
 */
export interface AvailableModelsResponse {
    /**
     * List of models available in this region
     * @type {Array<AgentModelInfo>}
     * @memberof AvailableModelsResponse
     */
    'models': Array<AgentModelInfo>;
}
/**
 * 
 * @export
 * @interface BooleanCustomizationField
 */
export interface BooleanCustomizationField {
    /**
     * 
     * @type {string}
     * @memberof BooleanCustomizationField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BooleanCustomizationField
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BooleanCustomizationField
     */
    'type': BooleanCustomizationFieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanCustomizationField
     */
    'value': boolean;
}

export const BooleanCustomizationFieldTypeEnum = {
    BOOLEAN: 'boolean'
} as const;

export type BooleanCustomizationFieldTypeEnum = typeof BooleanCustomizationFieldTypeEnum[keyof typeof BooleanCustomizationFieldTypeEnum];

/**
 * Tool that evaluates arithmetic expressions deterministically.
 * @export
 * @interface CalculatorToolConfig
 */
export interface CalculatorToolConfig {
    /**
     * 
     * @type {string}
     * @memberof CalculatorToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CalculatorToolConfig
     */
    'type'?: CalculatorToolConfigTypeEnum;
}

export const CalculatorToolConfigTypeEnum = {
    CALCULATOR: 'calculator'
} as const;

export type CalculatorToolConfigTypeEnum = typeof CalculatorToolConfigTypeEnum[keyof typeof CalculatorToolConfigTypeEnum];

/**
 * When invoked from a case.
 * @export
 * @interface CaseSourceContext
 */
export interface CaseSourceContext {
    /**
     * 
     * @type {string}
     * @memberof CaseSourceContext
     */
    'source_type'?: CaseSourceContextSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseSourceContext
     */
    'case_id': string;
}

export const CaseSourceContextSourceTypeEnum = {
    CASE: 'case'
} as const;

export type CaseSourceContextSourceTypeEnum = typeof CaseSourceContextSourceTypeEnum[keyof typeof CaseSourceContextSourceTypeEnum];

/**
 * 
 * @export
 * @interface Content
 */
export interface Content {
}
/**
 * 
 * @export
 * @interface ContentAnyOfInner
 */
export interface ContentAnyOfInner {
}
/**
 * @type ContextWindowStrategy
 * Strategy for truncating conversation history before LLM calls
 * @export
 */
export type ContextWindowStrategy = { kind: 'trim_to_last_n' } & TrimToLastN | { kind: 'untrimmed' } & Untrimmed;

/**
 * 
 * @export
 * @interface CredentialItem
 */
export interface CredentialItem {
    /**
     * 
     * @type {string}
     * @memberof CredentialItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CredentialItem
     */
    'name': string;
    /**
     * 
     * @type {ModelProvider}
     * @memberof CredentialItem
     */
    'provider': ModelProvider;
    /**
     * 
     * @type {string}
     * @memberof CredentialItem
     */
    'last_updated': string | null;
    /**
     * 
     * @type {string}
     * @memberof CredentialItem
     */
    'updated_by': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CredentialItem
     */
    'allow_test_invocations'?: boolean;
    /**
     * 
     * @type {{ [key: string]: EnvCredentialConfig; }}
     * @memberof CredentialItem
     */
    'env_configs'?: { [key: string]: EnvCredentialConfig; };
    /**
     * 
     * @type {Array<Model>}
     * @memberof CredentialItem
     */
    'models'?: Array<Model>;
}


/**
 * 
 * @export
 * @interface CredentialListResponse
 */
export interface CredentialListResponse {
    /**
     * 
     * @type {Array<CredentialItem>}
     * @memberof CredentialListResponse
     */
    'credentials': Array<CredentialItem>;
}
/**
 * 
 * @export
 * @interface CredentialTestResult
 */
export interface CredentialTestResult {
    /**
     * 
     * @type {boolean}
     * @memberof CredentialTestResult
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CredentialTestResult
     */
    'message': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CredentialTestResult
     */
    'details'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface CredentialUpdateRequest
 */
export interface CredentialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CredentialUpdateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CredentialUpdateRequest
     */
    'models'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CredentialUpdateRequest
     */
    'credential'?: { [key: string]: any; } | null;
}
/**
 * A named group of customization fields shown for a prebuilt agent.
 * @export
 * @interface CustomizationCategory
 */
export interface CustomizationCategory {
    /**
     * 
     * @type {string}
     * @memberof CustomizationCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationCategory
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<CustomizationCategoryFieldsInner>}
     * @memberof CustomizationCategory
     */
    'fields'?: Array<CustomizationCategoryFieldsInner>;
}
/**
 * @type CustomizationCategoryFieldsInner
 * @export
 */
export type CustomizationCategoryFieldsInner = { type: 'boolean' } & BooleanCustomizationField | { type: 'enum' } & EnumCustomizationField | { type: 'multi_select' } & MultiSelectCustomizationField | { type: 'text' } & TextCustomizationField;

/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof Data
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Data
     */
    'structured_input'?: { [key: string]: any; };
    /**
     * User message to send to the agent
     * @type {string}
     * @memberof Data
     */
    'invocation_message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Data
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof Data
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'session_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type'?: DataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'source'?: DataSourceEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof Data
     */
    'flow_context': FlowRuntimeContext;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'client_timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'case_id': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'playground_id': string;
}

export const DataTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];
export const DataSourceEnum = {
    PLAYGROUND: 'playground'
} as const;

export type DataSourceEnum = typeof DataSourceEnum[keyof typeof DataSourceEnum];

/**
 * 
 * @export
 * @interface EnumCustomizationField
 */
export interface EnumCustomizationField {
    /**
     * 
     * @type {string}
     * @memberof EnumCustomizationField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EnumCustomizationField
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumCustomizationField
     */
    'type': EnumCustomizationFieldTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumCustomizationField
     */
    'options': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EnumCustomizationField
     */
    'value': string;
}

export const EnumCustomizationFieldTypeEnum = {
    ENUM: 'enum'
} as const;

export type EnumCustomizationFieldTypeEnum = typeof EnumCustomizationFieldTypeEnum[keyof typeof EnumCustomizationFieldTypeEnum];

/**
 * Non-sensitive per-environment configuration stored alongside a credential.
 * @export
 * @interface EnvCredentialConfig
 */
export interface EnvCredentialConfig {
    /**
     * 
     * @type {string}
     * @memberof EnvCredentialConfig
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnvCredentialConfig
     */
    'project_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnvCredentialConfig
     */
    'location'?: string;
}
/**
 * Taktile execution environment.
 * @export
 * @enum {string}
 */

export const Environment = {
    PRODUCTION: 'production',
    SANDBOX: 'sandbox'
} as const;

export type Environment = typeof Environment[keyof typeof Environment];


/**
 * Execution configuration for agent runtime limits and behavior.  All fields are optional - if not provided, defaults are used at runtime.  IMPORTANT: Don\'t use raw fields directly (optional user-defined values). Always use properties (e.g., `max_steps_per_session`) with default fallback.
 * @export
 * @interface ExecutionConfig
 */
export interface ExecutionConfig {
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'session_max_lifetime_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'invocation_max_runtime_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'max_steps_per_session'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_http_timeout_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_retry_max_retries'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_loop_repetition_threshold'?: number | null;
    /**
     * 
     * @type {ContextWindowStrategy}
     * @memberof ExecutionConfig
     */
    'context_window_strategy'?: ContextWindowStrategy;
}
/**
 * Execution activity and timing metrics.
 * @export
 * @interface ExecutionMetricsResponse
 */
export interface ExecutionMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'llm_call_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'tool_call_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'user_tool_call_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'num_iterations'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'active_runtime_ms'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutionMetricsResponse
     */
    'session_duration_ms'?: number;
    /**
     * 
     * @type {{ [key: string]: TimekeepingCategorySummary; }}
     * @memberof ExecutionMetricsResponse
     */
    'runtime_by_category'?: { [key: string]: TimekeepingCategorySummary; };
}
/**
 * Synchronous invocation is used for SSE streaming.
 * @export
 * @enum {string}
 */

export const ExecutionMode = {
    SYNC: 'sync',
    ASYNC: 'async'
} as const;

export type ExecutionMode = typeof ExecutionMode[keyof typeof ExecutionMode];


/**
 * 
 * @export
 * @interface FlowId
 */
export interface FlowId {
}
/**
 * Context information about the flow execution environment.  Provides metadata about the flow, decision, and execution environment when an agent is invoked from within a flow.
 * @export
 * @interface FlowRuntimeContext
 */
export interface FlowRuntimeContext {
    /**
     * 
     * @type {FlowId}
     * @memberof FlowRuntimeContext
     */
    'flow_id': FlowId;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'flow_version_name'?: string | null;
    /**
     * 
     * @type {FlowVersionId}
     * @memberof FlowRuntimeContext
     */
    'flow_version_id'?: FlowVersionId | null;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'node_id'?: string | null;
    /**
     * 
     * @type {Environment}
     * @memberof FlowRuntimeContext
     */
    'environment'?: Environment;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'continuation_header'?: string | null;
}


/**
 * When invoked from a flow.
 * @export
 * @interface FlowSourceContext
 */
export interface FlowSourceContext {
    /**
     * 
     * @type {string}
     * @memberof FlowSourceContext
     */
    'source_type'?: FlowSourceContextSourceTypeEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof FlowSourceContext
     */
    'flow_context': FlowRuntimeContext;
}

export const FlowSourceContextSourceTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowSourceContextSourceTypeEnum = typeof FlowSourceContextSourceTypeEnum[keyof typeof FlowSourceContextSourceTypeEnum];

/**
 * Configuration for a flow tool that calls a Taktile flow.
 * @export
 * @interface FlowToolConfigInput
 */
export interface FlowToolConfigInput {
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'type'?: FlowToolConfigInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'description'?: string;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigInput
     */
    'input_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'output_type'?: FlowToolConfigInputOutputTypeEnum;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigInput
     */
    'output_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof FlowToolConfigInput
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigInput
     */
    'input_schema_metadata_overlay'?: MetadataOverlay | null;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigInput
     */
    'output_schema_metadata_overlay'?: MetadataOverlay | null;
}

export const FlowToolConfigInputTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowToolConfigInputTypeEnum = typeof FlowToolConfigInputTypeEnum[keyof typeof FlowToolConfigInputTypeEnum];
export const FlowToolConfigInputOutputTypeEnum = {
    JSON: 'json'
} as const;

export type FlowToolConfigInputOutputTypeEnum = typeof FlowToolConfigInputOutputTypeEnum[keyof typeof FlowToolConfigInputOutputTypeEnum];

/**
 * Configuration for a flow tool that calls a Taktile flow.
 * @export
 * @interface FlowToolConfigOutput
 */
export interface FlowToolConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'type'?: FlowToolConfigOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'description'?: string;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigOutput
     */
    'input_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'output_type'?: FlowToolConfigOutputOutputTypeEnum;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigOutput
     */
    'output_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof FlowToolConfigOutput
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigOutput
     */
    'input_schema_metadata_overlay'?: MetadataOverlay | null;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigOutput
     */
    'output_schema_metadata_overlay'?: MetadataOverlay | null;
}

export const FlowToolConfigOutputTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowToolConfigOutputTypeEnum = typeof FlowToolConfigOutputTypeEnum[keyof typeof FlowToolConfigOutputTypeEnum];
export const FlowToolConfigOutputOutputTypeEnum = {
    JSON: 'json'
} as const;

export type FlowToolConfigOutputOutputTypeEnum = typeof FlowToolConfigOutputOutputTypeEnum[keyof typeof FlowToolConfigOutputOutputTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const FlowToolExecutionMode = {
    SYNC: 'sync',
    ASYNC: 'async'
} as const;

export type FlowToolExecutionMode = typeof FlowToolExecutionMode[keyof typeof FlowToolExecutionMode];


/**
 * 
 * @export
 * @interface FlowVersionId
 */
export interface FlowVersionId {
}
/**
 * 
 * @export
 * @interface GetCaseByIdToolConfig
 */
export interface GetCaseByIdToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetCaseByIdToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseByIdToolConfig
     */
    'type'?: GetCaseByIdToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCaseByIdToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseByIdToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseByIdToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetCaseByIdToolConfig
     */
    'output_type'?: GetCaseByIdToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseByIdToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetCaseByIdToolConfigTypeEnum = {
    GET_CASE_BY_ID: 'get_case_by_id'
} as const;

export type GetCaseByIdToolConfigTypeEnum = typeof GetCaseByIdToolConfigTypeEnum[keyof typeof GetCaseByIdToolConfigTypeEnum];
export const GetCaseByIdToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetCaseByIdToolConfigOutputTypeEnum = typeof GetCaseByIdToolConfigOutputTypeEnum[keyof typeof GetCaseByIdToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface GetCaseHintsToolConfig
 */
export interface GetCaseHintsToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetCaseHintsToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHintsToolConfig
     */
    'type'?: GetCaseHintsToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHintsToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHintsToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseHintsToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetCaseHintsToolConfig
     */
    'output_type'?: GetCaseHintsToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseHintsToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetCaseHintsToolConfigTypeEnum = {
    GET_CASE_HINTS: 'get_case_hints'
} as const;

export type GetCaseHintsToolConfigTypeEnum = typeof GetCaseHintsToolConfigTypeEnum[keyof typeof GetCaseHintsToolConfigTypeEnum];
export const GetCaseHintsToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetCaseHintsToolConfigOutputTypeEnum = typeof GetCaseHintsToolConfigOutputTypeEnum[keyof typeof GetCaseHintsToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface GetCaseHistoryToolConfig
 */
export interface GetCaseHistoryToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetCaseHistoryToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHistoryToolConfig
     */
    'type'?: GetCaseHistoryToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHistoryToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCaseHistoryToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseHistoryToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetCaseHistoryToolConfig
     */
    'output_type'?: GetCaseHistoryToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetCaseHistoryToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetCaseHistoryToolConfigTypeEnum = {
    GET_CASE_HISTORY: 'get_case_history'
} as const;

export type GetCaseHistoryToolConfigTypeEnum = typeof GetCaseHistoryToolConfigTypeEnum[keyof typeof GetCaseHistoryToolConfigTypeEnum];
export const GetCaseHistoryToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetCaseHistoryToolConfigOutputTypeEnum = typeof GetCaseHistoryToolConfigOutputTypeEnum[keyof typeof GetCaseHistoryToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface GetEntityByIdToolConfig
 */
export interface GetEntityByIdToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetEntityByIdToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEntityByIdToolConfig
     */
    'type'?: GetEntityByIdToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEntityByIdToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetEntityByIdToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetEntityByIdToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetEntityByIdToolConfig
     */
    'output_type'?: GetEntityByIdToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetEntityByIdToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetEntityByIdToolConfigTypeEnum = {
    GET_ENTITY_BY_ID: 'get_entity_by_id'
} as const;

export type GetEntityByIdToolConfigTypeEnum = typeof GetEntityByIdToolConfigTypeEnum[keyof typeof GetEntityByIdToolConfigTypeEnum];
export const GetEntityByIdToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetEntityByIdToolConfigOutputTypeEnum = typeof GetEntityByIdToolConfigOutputTypeEnum[keyof typeof GetEntityByIdToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface GetEventByIdToolConfig
 */
export interface GetEventByIdToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetEventByIdToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventByIdToolConfig
     */
    'type'?: GetEventByIdToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEventByIdToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventByIdToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetEventByIdToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetEventByIdToolConfig
     */
    'output_type'?: GetEventByIdToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetEventByIdToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetEventByIdToolConfigTypeEnum = {
    GET_EVENT_BY_ID: 'get_event_by_id'
} as const;

export type GetEventByIdToolConfigTypeEnum = typeof GetEventByIdToolConfigTypeEnum[keyof typeof GetEventByIdToolConfigTypeEnum];
export const GetEventByIdToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetEventByIdToolConfigOutputTypeEnum = typeof GetEventByIdToolConfigOutputTypeEnum[keyof typeof GetEventByIdToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface GetRelatedEntitiesToolConfig
 */
export interface GetRelatedEntitiesToolConfig {
    /**
     * 
     * @type {string}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'type'?: GetRelatedEntitiesToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'output_type'?: GetRelatedEntitiesToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetRelatedEntitiesToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const GetRelatedEntitiesToolConfigTypeEnum = {
    GET_RELATED_ENTITIES: 'get_related_entities'
} as const;

export type GetRelatedEntitiesToolConfigTypeEnum = typeof GetRelatedEntitiesToolConfigTypeEnum[keyof typeof GetRelatedEntitiesToolConfigTypeEnum];
export const GetRelatedEntitiesToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type GetRelatedEntitiesToolConfigOutputTypeEnum = typeof GetRelatedEntitiesToolConfigOutputTypeEnum[keyof typeof GetRelatedEntitiesToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Message from a human user.
 * @export
 * @interface HumanMessage
 */
export interface HumanMessage {
    /**
     * 
     * @type {string}
     * @memberof HumanMessage
     */
    'type'?: HumanMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HumanMessage
     */
    'id'?: string | null;
    /**
     * 
     * @type {Content}
     * @memberof HumanMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HumanMessage
     */
    'structured_input'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof HumanMessage
     */
    'invocation_message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HumanMessage
     */
    'token_count': number | null;
}

export const HumanMessageTypeEnum = {
    HUMAN: 'human'
} as const;

export type HumanMessageTypeEnum = typeof HumanMessageTypeEnum[keyof typeof HumanMessageTypeEnum];

/**
 * Control parameters for agent execution.
 * @export
 * @interface InvokeControl
 */
export interface InvokeControl {
    /**
     * 
     * @type {ExecutionMode}
     * @memberof InvokeControl
     */
    'execution_mode'?: ExecutionMode;
    /**
     * 
     * @type {Environment}
     * @memberof InvokeControl
     */
    'environment'?: Environment;
}


/**
 * 
 * @export
 * @interface ListCasesToolConfig
 */
export interface ListCasesToolConfig {
    /**
     * 
     * @type {string}
     * @memberof ListCasesToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ListCasesToolConfig
     */
    'type'?: ListCasesToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ListCasesToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ListCasesToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListCasesToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ListCasesToolConfig
     */
    'output_type'?: ListCasesToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListCasesToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const ListCasesToolConfigTypeEnum = {
    LIST_CASES: 'list_cases'
} as const;

export type ListCasesToolConfigTypeEnum = typeof ListCasesToolConfigTypeEnum[keyof typeof ListCasesToolConfigTypeEnum];
export const ListCasesToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type ListCasesToolConfigOutputTypeEnum = typeof ListCasesToolConfigOutputTypeEnum[keyof typeof ListCasesToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface ListEntityTypeSchemasToolConfig
 */
export interface ListEntityTypeSchemasToolConfig {
    /**
     * 
     * @type {string}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'type'?: ListEntityTypeSchemasToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'output_type'?: ListEntityTypeSchemasToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListEntityTypeSchemasToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const ListEntityTypeSchemasToolConfigTypeEnum = {
    LIST_ENTITY_TYPE_SCHEMAS: 'list_entity_type_schemas'
} as const;

export type ListEntityTypeSchemasToolConfigTypeEnum = typeof ListEntityTypeSchemasToolConfigTypeEnum[keyof typeof ListEntityTypeSchemasToolConfigTypeEnum];
export const ListEntityTypeSchemasToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type ListEntityTypeSchemasToolConfigOutputTypeEnum = typeof ListEntityTypeSchemasToolConfigOutputTypeEnum[keyof typeof ListEntityTypeSchemasToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface ListEventTypeSchemasToolConfig
 */
export interface ListEventTypeSchemasToolConfig {
    /**
     * 
     * @type {string}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'type'?: ListEventTypeSchemasToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'output_type'?: ListEventTypeSchemasToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ListEventTypeSchemasToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const ListEventTypeSchemasToolConfigTypeEnum = {
    LIST_EVENT_TYPE_SCHEMAS: 'list_event_type_schemas'
} as const;

export type ListEventTypeSchemasToolConfigTypeEnum = typeof ListEventTypeSchemasToolConfigTypeEnum[keyof typeof ListEventTypeSchemasToolConfigTypeEnum];
export const ListEventTypeSchemasToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type ListEventTypeSchemasToolConfigOutputTypeEnum = typeof ListEventTypeSchemasToolConfigOutputTypeEnum[keyof typeof ListEventTypeSchemasToolConfigOutputTypeEnum];

/**
 * Status-specific live metadata pushed by middleware while the session is active. Visible via the poll-based GET endpoint without being part of the session state machine.  Stale-check: clients should treat the entry as stale once ``now > until`` and fall back to ``Session.status``. The repository force-clears the field on any transition to a non-active status. The API response layer additionally filters expired entries on read so clients never observe a stale entry even if the DB row hasn\'t been overwritten yet.
 * @export
 * @interface LiveStatusDetail
 */
export interface LiveStatusDetail {
    /**
     * 
     * @type {LiveStatusDetailKind}
     * @memberof LiveStatusDetail
     */
    'kind': LiveStatusDetailKind;
    /**
     * 
     * @type {string}
     * @memberof LiveStatusDetail
     */
    'at': string;
    /**
     * 
     * @type {string}
     * @memberof LiveStatusDetail
     */
    'until': string;
}


/**
 * Discriminator for `LiveStatusDetail`
 * @export
 * @enum {string}
 */

export const LiveStatusDetailKind = {
    RETRYING: 'retrying'
} as const;

export type LiveStatusDetailKind = typeof LiveStatusDetailKind[keyof typeof LiveStatusDetailKind];


/**
 * Overlay for enriching a flow\'s JSONSchema (input or output) with agent-specific metadata.  Maps property names to their metadata overlays. During schema resolution, each property\'s overlay is merged into the corresponding property definition from the base flow schema.  We currently only allow overlays on top-level properties, not nested ones.  Note: Schema-level title and description are provided via the base tool config fields (name, description), not here.  Example:     Given a flow with schema:     {         \"properties\": {             \"customer_id\": {\"type\": \"string\"},             \"amount\": {\"type\": \"number\"}         }     }      An overlay might be:     {         \"properties\": {             \"customer_id\": {                 \"description\": \"The unique customer identifier from the CRM\"             },             \"amount\": {                 \"description\": \"Transaction amount in USD\"             }         }     }
 * @export
 * @interface MetadataOverlay
 */
export interface MetadataOverlay {
    /**
     * 
     * @type {{ [key: string]: PropertyMetadataOverlay; }}
     * @memberof MetadataOverlay
     */
    'properties': { [key: string]: PropertyMetadataOverlay; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Model = {
    CLAUDE_4_7_OPUS: 'claude-4-7-opus',
    CLAUDE_4_6_OPUS: 'claude-4-6-opus',
    CLAUDE_4_6_SONNET: 'claude-4-6-sonnet',
    CLAUDE_4_5_SONNET: 'claude-4-5-sonnet',
    CLAUDE_3_7_SONNET: 'claude-3-7-sonnet',
    CLAUDE_3_5_SONNET_V2: 'claude-3-5-sonnet-v2',
    CLAUDE_3_5_SONNET: 'claude-3-5-sonnet',
    CLAUDE_3_SONNET: 'claude-3-sonnet',
    CLAUDE_4_5_HAIKU: 'claude-4-5-haiku',
    CLAUDE_3_5_HAIKU: 'claude-3-5-haiku',
    CLAUDE_3_HAIKU: 'claude-3-haiku',
    CLAUDE_4_7_OPUS_ANTHROPIC: 'claude-4-7-opus-anthropic',
    CLAUDE_4_6_OPUS_ANTHROPIC: 'claude-4-6-opus-anthropic',
    CLAUDE_4_6_SONNET_ANTHROPIC: 'claude-4-6-sonnet-anthropic',
    CLAUDE_4_5_HAIKU_ANTHROPIC: 'claude-4-5-haiku-anthropic',
    DEEPSEEK_R1: 'deepseek-r1',
    AMAZON_NOVA_PRO: 'amazon-nova-pro',
    GPT_5: 'gpt-5',
    GPT_5_MINI: 'gpt-5-mini',
    GPT_4_1: 'gpt-4-1',
    GPT_4_1_MINI: 'gpt-4-1-mini',
    GPT_5_1: 'gpt-5-1',
    GPT_5_2: 'gpt-5-2',
    GPT_5_2_PRO: 'gpt-5-2-pro',
    GPT_5_4: 'gpt-5-4',
    GPT_5_4_PRO: 'gpt-5-4-pro',
    GPT_5_4_MINI: 'gpt-5-4-mini',
    GPT_5_5: 'gpt-5-5',
    GPT_5_5_PRO: 'gpt-5-5-pro',
    GEMINI_2_5_PRO: 'gemini-2-5-pro',
    GEMINI_2_5_FLASH: 'gemini-2-5-flash',
    GEMINI_2_5_FLASH_LITE: 'gemini-2-5-flash-lite',
    GEMINI_3_FLASH_PREVIEW: 'gemini-3-flash-preview',
    GEMINI_3_1_PRO_PREVIEW: 'gemini-3-1-pro-preview',
    GEMINI_3_1_FLASH_LITE_PREVIEW: 'gemini-3-1-flash-lite-preview',
    GEMINI_3_5_FLASH: 'gemini-3-5-flash'
} as const;

export type Model = typeof Model[keyof typeof Model];


/**
 * 
 * @export
 * @enum {string}
 */

export const ModelProvider = {
    BEDROCK: 'bedrock',
    OPENAI: 'openai',
    GOOGLE_VERTEX: 'google_vertex',
    ANTHROPIC: 'anthropic'
} as const;

export type ModelProvider = typeof ModelProvider[keyof typeof ModelProvider];


/**
 * 
 * @export
 * @interface MultiSelectCustomizationField
 */
export interface MultiSelectCustomizationField {
    /**
     * 
     * @type {string}
     * @memberof MultiSelectCustomizationField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MultiSelectCustomizationField
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MultiSelectCustomizationField
     */
    'type': MultiSelectCustomizationFieldTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiSelectCustomizationField
     */
    'options': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiSelectCustomizationField
     */
    'value': Array<string>;
}

export const MultiSelectCustomizationFieldTypeEnum = {
    MULTI_SELECT: 'multi_select'
} as const;

export type MultiSelectCustomizationFieldTypeEnum = typeof MultiSelectCustomizationFieldTypeEnum[keyof typeof MultiSelectCustomizationFieldTypeEnum];

/**
 * 
 * @export
 * @interface PatchCaseActionHintToolConfig
 */
export interface PatchCaseActionHintToolConfig {
    /**
     * 
     * @type {string}
     * @memberof PatchCaseActionHintToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseActionHintToolConfig
     */
    'type'?: PatchCaseActionHintToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseActionHintToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseActionHintToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchCaseActionHintToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PatchCaseActionHintToolConfig
     */
    'output_type'?: PatchCaseActionHintToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchCaseActionHintToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const PatchCaseActionHintToolConfigTypeEnum = {
    PATCH_CASE_ACTION_HINT: 'patch_case_action_hint'
} as const;

export type PatchCaseActionHintToolConfigTypeEnum = typeof PatchCaseActionHintToolConfigTypeEnum[keyof typeof PatchCaseActionHintToolConfigTypeEnum];
export const PatchCaseActionHintToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type PatchCaseActionHintToolConfigOutputTypeEnum = typeof PatchCaseActionHintToolConfigOutputTypeEnum[keyof typeof PatchCaseActionHintToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface PatchCaseTaskHintToolConfig
 */
export interface PatchCaseTaskHintToolConfig {
    /**
     * 
     * @type {string}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'type'?: PatchCaseTaskHintToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'output_type'?: PatchCaseTaskHintToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchCaseTaskHintToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const PatchCaseTaskHintToolConfigTypeEnum = {
    PATCH_CASE_TASK_HINT: 'patch_case_task_hint'
} as const;

export type PatchCaseTaskHintToolConfigTypeEnum = typeof PatchCaseTaskHintToolConfigTypeEnum[keyof typeof PatchCaseTaskHintToolConfigTypeEnum];
export const PatchCaseTaskHintToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type PatchCaseTaskHintToolConfigOutputTypeEnum = typeof PatchCaseTaskHintToolConfigOutputTypeEnum[keyof typeof PatchCaseTaskHintToolConfigOutputTypeEnum];

/**
 * Suggest or clear the recommended next action on a case so the investigator sees a highlighted action in the UI.
 * @export
 * @interface PatchHintedNextActionToolConfig
 */
export interface PatchHintedNextActionToolConfig {
    /**
     * 
     * @type {string}
     * @memberof PatchHintedNextActionToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatchHintedNextActionToolConfig
     */
    'type'?: PatchHintedNextActionToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchHintedNextActionToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatchHintedNextActionToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchHintedNextActionToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PatchHintedNextActionToolConfig
     */
    'output_type'?: PatchHintedNextActionToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchHintedNextActionToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const PatchHintedNextActionToolConfigTypeEnum = {
    PATCH_HINTED_NEXT_ACTION: 'patch_hinted_next_action'
} as const;

export type PatchHintedNextActionToolConfigTypeEnum = typeof PatchHintedNextActionToolConfigTypeEnum[keyof typeof PatchHintedNextActionToolConfigTypeEnum];
export const PatchHintedNextActionToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type PatchHintedNextActionToolConfigOutputTypeEnum = typeof PatchHintedNextActionToolConfigOutputTypeEnum[keyof typeof PatchHintedNextActionToolConfigOutputTypeEnum];

/**
 * Request to pre-warm an AgentCore container for a live agent invocation.  The caller-provided ``session_id`` is used as the AgentCore ``runtimeSessionId`` so a subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
 * @export
 * @interface PingRequest
 */
export interface PingRequest {
    /**
     * 
     * @type {string}
     * @memberof PingRequest
     */
    'type'?: PingRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PingRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof PingRequest
     */
    'session_id': string;
    /**
     * 
     * @type {Environment}
     * @memberof PingRequest
     */
    'environment'?: Environment;
}

export const PingRequestTypeEnum = {
    PING: 'ping'
} as const;

export type PingRequestTypeEnum = typeof PingRequestTypeEnum[keyof typeof PingRequestTypeEnum];

/**
 * Request to pre-warm a playground container for an agent version.
 * @export
 * @interface PlaygroundPingRequest
 */
export interface PlaygroundPingRequest {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'type'?: PlaygroundPingRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof PlaygroundPingRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'playground_id': string;
}

export const PlaygroundPingRequestTypeEnum = {
    PING: 'ping'
} as const;

export type PlaygroundPingRequestTypeEnum = typeof PlaygroundPingRequestTypeEnum[keyof typeof PlaygroundPingRequestTypeEnum];

/**
 * Response from playground ping.
 * @export
 * @interface PlaygroundPingResponse
 */
export interface PlaygroundPingResponse {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingResponse
     */
    'type'?: PlaygroundPingResponseTypeEnum;
}

export const PlaygroundPingResponseTypeEnum = {
    PONG: 'pong'
} as const;

export type PlaygroundPingResponseTypeEnum = typeof PlaygroundPingResponseTypeEnum[keyof typeof PlaygroundPingResponseTypeEnum];

/**
 * When invoked from the playground.
 * @export
 * @interface PlaygroundSourceContext
 */
export interface PlaygroundSourceContext {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundSourceContext
     */
    'source_type'?: PlaygroundSourceContextSourceTypeEnum;
}

export const PlaygroundSourceContextSourceTypeEnum = {
    PLAYGROUND: 'playground'
} as const;

export type PlaygroundSourceContextSourceTypeEnum = typeof PlaygroundSourceContextSourceTypeEnum[keyof typeof PlaygroundSourceContextSourceTypeEnum];

/**
 * Marks an agent as prebuilt; `template` is optional provenance metadata.
 * @export
 * @interface PrebuiltConfiguration
 */
export interface PrebuiltConfiguration {
    /**
     * 
     * @type {PrebuiltTemplate}
     * @memberof PrebuiltConfiguration
     */
    'template'?: PrebuiltTemplate | null;
}
/**
 * Provenance of the template a prebuilt agent was generated from.
 * @export
 * @interface PrebuiltTemplate
 */
export interface PrebuiltTemplate {
    /**
     * Template slug
     * @type {string}
     * @memberof PrebuiltTemplate
     */
    'slug': string;
    /**
     * Git short SHA of the template revision
     * @type {string}
     * @memberof PrebuiltTemplate
     */
    'sha': string;
}
/**
 * Metadata overlay for a single JSONSchema property.  Used to enrich a flow\'s input schema with agent-specific metadata that helps the agent understand how to populate the property.
 * @export
 * @interface PropertyMetadataOverlay
 */
export interface PropertyMetadataOverlay {
    /**
     * 
     * @type {string}
     * @memberof PropertyMetadataOverlay
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface QueryEventsToolConfig
 */
export interface QueryEventsToolConfig {
    /**
     * 
     * @type {string}
     * @memberof QueryEventsToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryEventsToolConfig
     */
    'type'?: QueryEventsToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryEventsToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueryEventsToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QueryEventsToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof QueryEventsToolConfig
     */
    'output_type'?: QueryEventsToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QueryEventsToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const QueryEventsToolConfigTypeEnum = {
    QUERY_EVENTS: 'query_events'
} as const;

export type QueryEventsToolConfigTypeEnum = typeof QueryEventsToolConfigTypeEnum[keyof typeof QueryEventsToolConfigTypeEnum];
export const QueryEventsToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type QueryEventsToolConfigOutputTypeEnum = typeof QueryEventsToolConfigOutputTypeEnum[keyof typeof QueryEventsToolConfigOutputTypeEnum];

/**
 * 
 * @export
 * @interface QueryMetricsToolConfig
 */
export interface QueryMetricsToolConfig {
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'type'?: QueryMetricsToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QueryMetricsToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'output_type'?: QueryMetricsToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QueryMetricsToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof QueryMetricsToolConfig
     */
    'data_source'?: string | null;
}

export const QueryMetricsToolConfigTypeEnum = {
    QUERY_METRICS: 'query_metrics'
} as const;

export type QueryMetricsToolConfigTypeEnum = typeof QueryMetricsToolConfigTypeEnum[keyof typeof QueryMetricsToolConfigTypeEnum];
export const QueryMetricsToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type QueryMetricsToolConfigOutputTypeEnum = typeof QueryMetricsToolConfigOutputTypeEnum[keyof typeof QueryMetricsToolConfigOutputTypeEnum];

/**
 * Tool that reads a file and returns its content as multimodal content blocks.
 * @export
 * @interface ReadFileToolConfig
 */
export interface ReadFileToolConfig {
    /**
     * 
     * @type {string}
     * @memberof ReadFileToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileToolConfig
     */
    'type'?: ReadFileToolConfigTypeEnum;
}

export const ReadFileToolConfigTypeEnum = {
    READ_FILE: 'read_file'
} as const;

export type ReadFileToolConfigTypeEnum = typeof ReadFileToolConfigTypeEnum[keyof typeof ReadFileToolConfigTypeEnum];

/**
 * Standardized user-facing reasoning levels. Note: these abstract levels are mapped to provider-specific efforts (including token-based reasoning efforts).
 * @export
 * @enum {string}
 */

export const ReasoningLevel = {
    NONE: 'none',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high'
} as const;

export type ReasoningLevel = typeof ReasoningLevel[keyof typeof ReasoningLevel];


/**
 * 
 * @export
 * @interface ReplyVisualizeMetricsToolConfig
 */
export interface ReplyVisualizeMetricsToolConfig {
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'type'?: ReplyVisualizeMetricsToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'output_type'?: ReplyVisualizeMetricsToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'data_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'chart_format'?: ReplyVisualizeMetricsToolConfigChartFormatEnum;
    /**
     * 
     * @type {Array<SpecialDomain>}
     * @memberof ReplyVisualizeMetricsToolConfig
     */
    'special_domains'?: Array<SpecialDomain>;
}

export const ReplyVisualizeMetricsToolConfigTypeEnum = {
    REPLY_VISUALIZE_METRICS: 'reply_visualize_metrics'
} as const;

export type ReplyVisualizeMetricsToolConfigTypeEnum = typeof ReplyVisualizeMetricsToolConfigTypeEnum[keyof typeof ReplyVisualizeMetricsToolConfigTypeEnum];
export const ReplyVisualizeMetricsToolConfigOutputTypeEnum = {
    STRING: 'string'
} as const;

export type ReplyVisualizeMetricsToolConfigOutputTypeEnum = typeof ReplyVisualizeMetricsToolConfigOutputTypeEnum[keyof typeof ReplyVisualizeMetricsToolConfigOutputTypeEnum];
export const ReplyVisualizeMetricsToolConfigChartFormatEnum = {
    VEGA: 'vega'
} as const;

export type ReplyVisualizeMetricsToolConfigChartFormatEnum = typeof ReplyVisualizeMetricsToolConfigChartFormatEnum[keyof typeof ReplyVisualizeMetricsToolConfigChartFormatEnum];

/**
 * Lightweight session representation for list endpoints.  Excludes agent_version_config (separate DDB item, expensive to batch-read), result (stored in checkpoint), and messages.
 * @export
 * @interface SessionListItem
 */
export interface SessionListItem {
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'agent_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'agent_version_etag': string;
    /**
     * 
     * @type {Environment}
     * @memberof SessionListItem
     */
    'environment': Environment;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionListItem
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'session_mode': SessionListItemSessionModeEnum;
    /**
     * 
     * @type {Model}
     * @memberof SessionListItem
     */
    'model'?: Model | null;
    /**
     * 
     * @type {TerminationReason}
     * @memberof SessionListItem
     */
    'termination_reason'?: TerminationReason | null;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'termination_message'?: string | null;
    /**
     * 
     * @type {LiveStatusDetail}
     * @memberof SessionListItem
     */
    'live_status_detail'?: LiveStatusDetail | null;
    /**
     * 
     * @type {Trigger}
     * @memberof SessionListItem
     */
    'trigger': Trigger;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'created_by_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'finished_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionListItem
     */
    'updated_at': string;
    /**
     * 
     * @type {SessionMetricsResponse}
     * @memberof SessionListItem
     */
    'metrics': SessionMetricsResponse;
}

export const SessionListItemSessionModeEnum = {
    SINGLE_TURN: 'single_turn',
    MULTI_TURN: 'multi_turn'
} as const;

export type SessionListItemSessionModeEnum = typeof SessionListItemSessionModeEnum[keyof typeof SessionListItemSessionModeEnum];

/**
 * Paginated messages from a session checkpoint, with full session metadata.
 * @export
 * @interface SessionMessagesResponse
 */
export interface SessionMessagesResponse {
    /**
     * 
     * @type {SessionListItem}
     * @memberof SessionMessagesResponse
     */
    'session': SessionListItem;
    /**
     * 
     * @type {Array<SessionMessagesResponseMessagesInner>}
     * @memberof SessionMessagesResponse
     */
    'messages': Array<SessionMessagesResponseMessagesInner>;
    /**
     * 
     * @type {string}
     * @memberof SessionMessagesResponse
     */
    'next_cursor'?: string | null;
}
/**
 * @type SessionMessagesResponseMessagesInner
 * @export
 */
export type SessionMessagesResponseMessagesInner = { type: 'ai' } & AIMessage | { type: 'human' } & HumanMessage | { type: 'system' } & SystemMessage | { type: 'tool' } & ToolMessage;

/**
 * Metrics returned in API response.
 * @export
 * @interface SessionMetricsResponse
 */
export interface SessionMetricsResponse {
    /**
     * 
     * @type {UsageMetricsResponse}
     * @memberof SessionMetricsResponse
     */
    'usage': UsageMetricsResponse;
    /**
     * 
     * @type {ExecutionMetricsResponse}
     * @memberof SessionMetricsResponse
     */
    'execution': ExecutionMetricsResponse;
}
/**
 * API response for GET /sessions/{session_id}.  Extends the base with agent_version_config, result, and messages.
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'agent_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'agent_version_etag': string;
    /**
     * 
     * @type {Environment}
     * @memberof SessionResponse
     */
    'environment': Environment;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionResponse
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'session_mode': SessionResponseSessionModeEnum;
    /**
     * 
     * @type {Model}
     * @memberof SessionResponse
     */
    'model'?: Model | null;
    /**
     * 
     * @type {TerminationReason}
     * @memberof SessionResponse
     */
    'termination_reason'?: TerminationReason | null;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'termination_message'?: string | null;
    /**
     * 
     * @type {LiveStatusDetail}
     * @memberof SessionResponse
     */
    'live_status_detail'?: LiveStatusDetail | null;
    /**
     * 
     * @type {Trigger}
     * @memberof SessionResponse
     */
    'trigger': Trigger;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'created_by_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'finished_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {SessionMetricsResponse}
     * @memberof SessionResponse
     */
    'metrics': SessionMetricsResponse;
    /**
     * 
     * @type {AgentVersionConfigurationOutput}
     * @memberof SessionResponse
     */
    'agent_version_config': AgentVersionConfigurationOutput;
    /**
     * 
     * @type {SessionResultResponse}
     * @memberof SessionResponse
     */
    'result'?: SessionResultResponse | null;
    /**
     * 
     * @type {Array<SessionMessagesResponseMessagesInner>}
     * @memberof SessionResponse
     */
    'messages'?: Array<SessionMessagesResponseMessagesInner> | null;
}

export const SessionResponseSessionModeEnum = {
    SINGLE_TURN: 'single_turn',
    MULTI_TURN: 'multi_turn'
} as const;

export type SessionResponseSessionModeEnum = typeof SessionResponseSessionModeEnum[keyof typeof SessionResponseSessionModeEnum];

/**
 * API response schema for session result.
 * @export
 * @interface SessionResultResponse
 */
export interface SessionResultResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResultResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SessionResultResponse
     */
    'structured_output'?: { [key: string]: any; } | null;
}
/**
 * Defines the lifecycle of an agent session.  Pre-execution state: - pending: Session created but not yet running (version/flow resolution in progress)  Active states: - running: Agent is currently executing in Langchain - paused: Agent is paused (async dependency or HITL)  Terminal states: - success: Completed successfully with final output - failed: Irrecoverable error (with termination_reason) - cancelled: Manually cancelled by user/API or programmatically
 * @export
 * @enum {string}
 */

export const SessionStatus = {
    PENDING: 'pending',
    RUNNING: 'running',
    PAUSED: 'paused',
    SUCCESS: 'success',
    FAILED: 'failed',
    CANCELLED: 'cancelled'
} as const;

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    ASC: 'asc',
    DESC: 'desc'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortField = {
    STARTED_AT: 'started_at',
    DURATION: 'duration',
    TOKENS: 'tokens'
} as const;

export type SortField = typeof SortField[keyof typeof SortField];


/**
 * A named semantic dimension whose color encoding must be stable across charts.  \"Special\" because only a curated set of columns is tagged — not every column the LLM might emit.
 * @export
 * @interface SpecialDomain
 */
export interface SpecialDomain {
    /**
     * Identifier the LLM uses to tag the encoding.
     * @type {string}
     * @memberof SpecialDomain
     */
    'name': string;
    /**
     * Rendered into the tool prompt verbatim.
     * @type {string}
     * @memberof SpecialDomain
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpecialDomain
     */
    'values'?: Array<string> | null;
}
/**
 * System message for priming AI behavior.
 * @export
 * @interface SystemMessage
 */
export interface SystemMessage {
    /**
     * 
     * @type {string}
     * @memberof SystemMessage
     */
    'type'?: SystemMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SystemMessage
     */
    'id'?: string | null;
    /**
     * 
     * @type {Content}
     * @memberof SystemMessage
     */
    'content': Content;
}

export const SystemMessageTypeEnum = {
    SYSTEM: 'system'
} as const;

export type SystemMessageTypeEnum = typeof SystemMessageTypeEnum[keyof typeof SystemMessageTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TerminationReason = {
    EXPIRED: 'expired',
    INVOCATION_RUNTIME_LIMIT: 'invocation_runtime_limit',
    MODEL_CALL_LIMIT: 'model_call_limit',
    TOOL_CALL_LIMIT: 'tool_call_limit',
    INFINITE_TOOL_LOOP: 'infinite_tool_loop',
    REPETITIVE_TEXT_OUTPUT: 'repetitive_text_output',
    QUOTA_EXHAUSTED: 'quota_exhausted',
    RATE_LIMIT_EXCEEDED: 'rate_limit_exceeded',
    REDRIVE_LIMIT_EXCEEDED: 'redrive_limit_exceeded',
    LLM_PROVIDER_BAD_REQUEST: 'llm_provider_bad_request',
    LLM_PROVIDER_RATE_LIMIT: 'llm_provider_rate_limit',
    LLM_PROVIDER_BYOK_AUTH_ERROR: 'llm_provider_byok_auth_error',
    LLM_PROVIDER_CONTEXT_WINDOW_EXCEEDED: 'llm_provider_context_window_exceeded',
    FILE_NOT_FOUND: 'file_not_found',
    TOOL_RATE_LIMIT_EXCEEDED: 'tool_rate_limit_exceeded',
    TOOL_REQUEST_TIMEOUT: 'tool_request_timeout',
    TOOL_EXECUTION_ERROR: 'tool_execution_error',
    TOOL_AUTH_ERROR: 'tool_auth_error',
    TOOL_DISCOVERY_ERROR: 'tool_discovery_error',
    FLOW_VERSION_NOT_FOUND: 'flow_version_not_found',
    RECURSION_LIMIT_EXCEEDED: 'recursion_limit_exceeded',
    ERROR: 'error',
    USER_CANCELLED: 'user_cancelled',
    UPSTREAM_CANCELLED: 'upstream_cancelled',
    VERSION_DIVERGED: 'version_diverged'
} as const;

export type TerminationReason = typeof TerminationReason[keyof typeof TerminationReason];


/**
 * When invoked from a test run.
 * @export
 * @interface TestRunSourceContext
 */
export interface TestRunSourceContext {
    /**
     * 
     * @type {string}
     * @memberof TestRunSourceContext
     */
    'source_type'?: TestRunSourceContextSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunSourceContext
     */
    'test_run_id': string;
}

export const TestRunSourceContextSourceTypeEnum = {
    TEST_RUN: 'test_run'
} as const;

export type TestRunSourceContextSourceTypeEnum = typeof TestRunSourceContextSourceTypeEnum[keyof typeof TestRunSourceContextSourceTypeEnum];

/**
 * Standard text output from AI response.
 * @export
 * @interface TextContentBlock
 */
export interface TextContentBlock {
    /**
     * Always \'text\'
     * @type {string}
     * @memberof TextContentBlock
     */
    'type'?: TextContentBlockTypeEnum;
    /**
     * The text content
     * @type {string}
     * @memberof TextContentBlock
     */
    'text': string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TextContentBlock
     */
    'annotations'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TextContentBlock
     */
    'extras'?: { [key: string]: any; } | null;
}

export const TextContentBlockTypeEnum = {
    TEXT: 'text'
} as const;

export type TextContentBlockTypeEnum = typeof TextContentBlockTypeEnum[keyof typeof TextContentBlockTypeEnum];

/**
 * 
 * @export
 * @interface TextCustomizationField
 */
export interface TextCustomizationField {
    /**
     * 
     * @type {string}
     * @memberof TextCustomizationField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TextCustomizationField
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextCustomizationField
     */
    'type': TextCustomizationFieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TextCustomizationField
     */
    'value': string;
}

export const TextCustomizationFieldTypeEnum = {
    TEXT: 'text'
} as const;

export type TextCustomizationFieldTypeEnum = typeof TextCustomizationFieldTypeEnum[keyof typeof TextCustomizationFieldTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TimekeepingCategory = {
    QUOTA_BACKOFF: 'quota_backoff',
    LLM_PROVIDER_RETRY: 'llm_provider_retry'
} as const;

export type TimekeepingCategory = typeof TimekeepingCategory[keyof typeof TimekeepingCategory];


/**
 * Per-category runtime aggregate across a session.  Stamped on Session.metrics.execution.runtime_by_category as the summary value of each category that fired during the session.
 * @export
 * @interface TimekeepingCategorySummary
 */
export interface TimekeepingCategorySummary {
    /**
     * 
     * @type {number}
     * @memberof TimekeepingCategorySummary
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimekeepingCategorySummary
     */
    'total_ms'?: number;
}
/**
 * Tool call content block from AI response.
 * @export
 * @interface ToolCallContentBlock
 */
export interface ToolCallContentBlock {
    /**
     * Always \'tool_call\'
     * @type {string}
     * @memberof ToolCallContentBlock
     */
    'type'?: ToolCallContentBlockTypeEnum;
    /**
     * Unique identifier for this tool call
     * @type {string}
     * @memberof ToolCallContentBlock
     */
    'id': string;
    /**
     * Name of the tool to call
     * @type {string}
     * @memberof ToolCallContentBlock
     */
    'name': string;
    /**
     * Arguments to pass to the tool
     * @type {{ [key: string]: any; }}
     * @memberof ToolCallContentBlock
     */
    'args': { [key: string]: any; };
    /**
     * 
     * @type {ToolMetadata}
     * @memberof ToolCallContentBlock
     */
    'metadata': ToolMetadata;
}

export const ToolCallContentBlockTypeEnum = {
    TOOL_CALL: 'tool_call'
} as const;

export type ToolCallContentBlockTypeEnum = typeof ToolCallContentBlockTypeEnum[keyof typeof ToolCallContentBlockTypeEnum];

/**
 * Result of a tool execution.
 * @export
 * @interface ToolMessage
 */
export interface ToolMessage {
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'type'?: ToolMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'id'?: string | null;
    /**
     * 
     * @type {Content}
     * @memberof ToolMessage
     */
    'content': Content;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'tool_call_id': string;
    /**
     * 
     * @type {ToolResultStatus}
     * @memberof ToolMessage
     */
    'status'?: ToolResultStatus;
    /**
     * 
     * @type {ToolMetadata}
     * @memberof ToolMessage
     */
    'metadata': ToolMetadata;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolMessage
     */
    'artifact'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'finished_at': string;
    /**
     * 
     * @type {number}
     * @memberof ToolMessage
     */
    'token_count': number | null;
}

export const ToolMessageTypeEnum = {
    TOOL: 'tool'
} as const;

export type ToolMessageTypeEnum = typeof ToolMessageTypeEnum[keyof typeof ToolMessageTypeEnum];

/**
 * Tool metadata enriched from agent configuration.
 * @export
 * @interface ToolMetadata
 */
export interface ToolMetadata {
    /**
     * 
     * @type {string}
     * @memberof ToolMetadata
     */
    'id': string;
    /**
     * 
     * @type {ToolType}
     * @memberof ToolMetadata
     */
    'type': ToolType;
    /**
     * 
     * @type {string}
     * @memberof ToolMetadata
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ToolMetadata
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof ToolMetadata
     */
    'description': string;
}


/**
 * Status of a tool execution result.
 * @export
 * @enum {string}
 */

export const ToolResultStatus = {
    SUCCESS: 'success',
    ERROR: 'error'
} as const;

export type ToolResultStatus = typeof ToolResultStatus[keyof typeof ToolResultStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ToolType = {
    FLOW: 'flow',
    EXTERNAL: 'external',
    STRUCTURED_OUTPUT: 'structured_output',
    SLEEP: 'sleep',
    ECHO: 'echo',
    RANDOM_NUMBER: 'random_number',
    READ_FILE: 'read_file',
    CALCULATOR: 'calculator',
    WEB_SEARCH: 'web_search',
    GET_CASE_BY_ID: 'get_case_by_id',
    GET_CASE_HINTS: 'get_case_hints',
    GET_CASE_HISTORY: 'get_case_history',
    GET_ENTITY_BY_ID: 'get_entity_by_id',
    GET_RELATED_ENTITIES: 'get_related_entities',
    LIST_CASES: 'list_cases',
    PATCH_CASE_TASK_HINT: 'patch_case_task_hint',
    PATCH_CASE_ACTION_HINT: 'patch_case_action_hint',
    PATCH_HINTED_NEXT_ACTION: 'patch_hinted_next_action',
    GET_EVENT_BY_ID: 'get_event_by_id',
    QUERY_EVENTS: 'query_events',
    LIST_ENTITY_TYPE_SCHEMAS: 'list_entity_type_schemas',
    LIST_EVENT_TYPE_SCHEMAS: 'list_event_type_schemas',
    QUERY_METRICS: 'query_metrics',
    REPLY_VISUALIZE_METRICS: 'reply_visualize_metrics'
} as const;

export type ToolType = typeof ToolType[keyof typeof ToolType];


/**
 * @type Trigger
 * @export
 */
export type Trigger = { source_type: 'analytics' } & AnalyticsSourceContext | { source_type: 'api' } & ApiSourceContext | { source_type: 'case' } & CaseSourceContext | { source_type: 'flow' } & FlowSourceContext | { source_type: 'playground' } & PlaygroundSourceContext | { source_type: 'test_run' } & TestRunSourceContext;

/**
 * 
 * @export
 * @interface TrimToLastN
 */
export interface TrimToLastN {
    /**
     * 
     * @type {string}
     * @memberof TrimToLastN
     */
    'kind'?: TrimToLastNKindEnum;
    /**
     * 
     * @type {number}
     * @memberof TrimToLastN
     */
    'n'?: number;
}

export const TrimToLastNKindEnum = {
    TRIM_TO_LAST_N: 'trim_to_last_n'
} as const;

export type TrimToLastNKindEnum = typeof TrimToLastNKindEnum[keyof typeof TrimToLastNKindEnum];

/**
 * 
 * @export
 * @interface Untrimmed
 */
export interface Untrimmed {
    /**
     * 
     * @type {string}
     * @memberof Untrimmed
     */
    'kind'?: UntrimmedKindEnum;
}

export const UntrimmedKindEnum = {
    UNTRIMMED: 'untrimmed'
} as const;

export type UntrimmedKindEnum = typeof UntrimmedKindEnum[keyof typeof UntrimmedKindEnum];

/**
 * Token usage and billing metrics.
 * @export
 * @interface UsageMetricsResponse
 */
export interface UsageMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'input_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'output_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'reasoning_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'total_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'total_cost_usd'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'current_context_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'peak_context_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'context_window_size'?: number;
    /**
     * Percentage of context window used by the most recent LLM call.
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'current_context_usage_pct': number;
    /**
     * Highest share of context window used by any LLM call this session.
     * @type {number}
     * @memberof UsageMetricsResponse
     */
    'peak_context_usage_pct': number;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * Tool that performs a public web search and returns ranked results.
 * @export
 * @interface WebSearchToolConfig
 */
export interface WebSearchToolConfig {
    /**
     * 
     * @type {string}
     * @memberof WebSearchToolConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WebSearchToolConfig
     */
    'type'?: WebSearchToolConfigTypeEnum;
}

export const WebSearchToolConfigTypeEnum = {
    WEB_SEARCH: 'web_search'
} as const;

export type WebSearchToolConfigTypeEnum = typeof WebSearchToolConfigTypeEnum[keyof typeof WebSearchToolConfigTypeEnum];


/**
 * AgentExecutionApi - axios parameter creator
 * @export
 */
export const AgentExecutionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost', 'sessionId', sessionId)
            const localVarPath = `/agents/management/api/v0/sessions/{session_id}/cancel`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost', 'sessionId', sessionId)
            const localVarPath = `/copilots/management/api/v0/sessions/{session_id}/cancel`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAgentsManagementApiV0SessionsSessionIdGet: async (sessionId: string, includeMessages?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionAgentsManagementApiV0SessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/agents/management/api/v0/sessions/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeMessages !== undefined) {
                localVarQueryParameter['include_messages'] = includeMessages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCopilotsManagementApiV0SessionsSessionIdGet: async (sessionId: string, includeMessages?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionCopilotsManagementApiV0SessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/copilots/management/api/v0/sessions/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeMessages !== undefined) {
                localVarQueryParameter['include_messages'] = includeMessages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentAgentsManagementApiV0InvokePost: async (data: Data, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('invokeAgentAgentsManagementApiV0InvokePost', 'data', data)
            const localVarPath = `/agents/management/api/v0/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentCopilotsManagementApiV0InvokePost: async (data: Data, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('invokeAgentCopilotsManagementApiV0InvokePost', 'data', data)
            const localVarPath = `/copilots/management/api/v0/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {string} sessionId 
         * @param {number} [pageSize] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet: async (sessionId: string, pageSize?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet', 'sessionId', sessionId)
            const localVarPath = `/agents/management/api/v0/sessions/{session_id}/messages`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {string} sessionId 
         * @param {number} [pageSize] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet: async (sessionId: string, pageSize?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet', 'sessionId', sessionId)
            const localVarPath = `/copilots/management/api/v0/sessions/{session_id}/messages`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {string} agentId 
         * @param {Environment} environment 
         * @param {string} from 
         * @param {string} to 
         * @param {number} pageSize 
         * @param {SortField} sortField 
         * @param {SortDirection} sortDirection 
         * @param {string | null} [cursor] 
         * @param {string | null} [status] 
         * @param {string | null} [agentVersionId] 
         * @param {string | null} [origin] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet: async (agentId: string, environment: Environment, from: string, to: string, pageSize: number, sortField: SortField, sortDirection: SortDirection, cursor?: string | null, status?: string | null, agentVersionId?: string | null, origin?: string | null, model?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'agentId', agentId)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'environment', environment)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'to', to)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'pageSize', pageSize)
            // verify required parameter 'sortField' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'sortField', sortField)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet', 'sortDirection', sortDirection)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/sessions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (agentVersionId !== undefined) {
                localVarQueryParameter['agent_version_id'] = agentVersionId;
            }

            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {string} agentId 
         * @param {Environment} environment 
         * @param {string} from 
         * @param {string} to 
         * @param {number} pageSize 
         * @param {SortField} sortField 
         * @param {SortDirection} sortDirection 
         * @param {string | null} [cursor] 
         * @param {string | null} [status] 
         * @param {string | null} [agentVersionId] 
         * @param {string | null} [origin] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet: async (agentId: string, environment: Environment, from: string, to: string, pageSize: number, sortField: SortField, sortDirection: SortDirection, cursor?: string | null, status?: string | null, agentVersionId?: string | null, origin?: string | null, model?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'agentId', agentId)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'environment', environment)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'to', to)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'pageSize', pageSize)
            // verify required parameter 'sortField' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'sortField', sortField)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet', 'sortDirection', sortDirection)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/sessions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (agentVersionId !== undefined) {
                localVarQueryParameter['agent_version_id'] = agentVersionId;
            }

            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {PingRequest} pingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingAgentsManagementApiV0PingPost: async (pingRequest: PingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pingRequest' is not null or undefined
            assertParamExists('pingAgentsManagementApiV0PingPost', 'pingRequest', pingRequest)
            const localVarPath = `/agents/management/api/v0/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {PingRequest} pingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingCopilotsManagementApiV0PingPost: async (pingRequest: PingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pingRequest' is not null or undefined
            assertParamExists('pingCopilotsManagementApiV0PingPost', 'pingRequest', pingRequest)
            const localVarPath = `/copilots/management/api/v0/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost: async (agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentPlaygroundInvokeRequest' is not null or undefined
            assertParamExists('playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost', 'agentPlaygroundInvokeRequest', agentPlaygroundInvokeRequest)
            const localVarPath = `/agents/management/api/v0/playground/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPlaygroundInvokeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost: async (agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentPlaygroundInvokeRequest' is not null or undefined
            assertParamExists('playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost', 'agentPlaygroundInvokeRequest', agentPlaygroundInvokeRequest)
            const localVarPath = `/copilots/management/api/v0/playground/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPlaygroundInvokeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingAgentsManagementApiV0PlaygroundPingPost: async (playgroundPingRequest: PlaygroundPingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playgroundPingRequest' is not null or undefined
            assertParamExists('playgroundPingAgentsManagementApiV0PlaygroundPingPost', 'playgroundPingRequest', playgroundPingRequest)
            const localVarPath = `/agents/management/api/v0/playground/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playgroundPingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingCopilotsManagementApiV0PlaygroundPingPost: async (playgroundPingRequest: PlaygroundPingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playgroundPingRequest' is not null or undefined
            assertParamExists('playgroundPingCopilotsManagementApiV0PlaygroundPingPost', 'playgroundPingRequest', playgroundPingRequest)
            const localVarPath = `/copilots/management/api/v0/playground/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playgroundPingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentExecutionApi - functional programming interface
 * @export
 */
export const AgentExecutionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentExecutionApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionAgentsManagementApiV0SessionsSessionIdGet(sessionId: string, includeMessages?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionAgentsManagementApiV0SessionsSessionIdGet(sessionId, includeMessages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.getSessionAgentsManagementApiV0SessionsSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionCopilotsManagementApiV0SessionsSessionIdGet(sessionId: string, includeMessages?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionCopilotsManagementApiV0SessionsSessionIdGet(sessionId, includeMessages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.getSessionCopilotsManagementApiV0SessionsSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invokeAgentAgentsManagementApiV0InvokePost(data: Data, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invokeAgentAgentsManagementApiV0InvokePost(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.invokeAgentAgentsManagementApiV0InvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invokeAgentCopilotsManagementApiV0InvokePost(data: Data, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invokeAgentCopilotsManagementApiV0InvokePost(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.invokeAgentCopilotsManagementApiV0InvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {string} sessionId 
         * @param {number} [pageSize] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(sessionId: string, pageSize?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(sessionId, pageSize, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {string} sessionId 
         * @param {number} [pageSize] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(sessionId: string, pageSize?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(sessionId, pageSize, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {string} agentId 
         * @param {Environment} environment 
         * @param {string} from 
         * @param {string} to 
         * @param {number} pageSize 
         * @param {SortField} sortField 
         * @param {SortDirection} sortDirection 
         * @param {string | null} [cursor] 
         * @param {string | null} [status] 
         * @param {string | null} [agentVersionId] 
         * @param {string | null} [origin] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(agentId: string, environment: Environment, from: string, to: string, pageSize: number, sortField: SortField, sortDirection: SortDirection, cursor?: string | null, status?: string | null, agentVersionId?: string | null, origin?: string | null, model?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(agentId, environment, from, to, pageSize, sortField, sortDirection, cursor, status, agentVersionId, origin, model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {string} agentId 
         * @param {Environment} environment 
         * @param {string} from 
         * @param {string} to 
         * @param {number} pageSize 
         * @param {SortField} sortField 
         * @param {SortDirection} sortDirection 
         * @param {string | null} [cursor] 
         * @param {string | null} [status] 
         * @param {string | null} [agentVersionId] 
         * @param {string | null} [origin] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(agentId: string, environment: Environment, from: string, to: string, pageSize: number, sortField: SortField, sortDirection: SortDirection, cursor?: string | null, status?: string | null, agentVersionId?: string | null, origin?: string | null, model?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(agentId, environment, from, to, pageSize, sortField, sortDirection, cursor, status, agentVersionId, origin, model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {PingRequest} pingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingAgentsManagementApiV0PingPost(pingRequest: PingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingAgentsManagementApiV0PingPost(pingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.pingAgentsManagementApiV0PingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {PingRequest} pingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingCopilotsManagementApiV0PingPost(pingRequest: PingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingCopilotsManagementApiV0PingPost(pingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.pingCopilotsManagementApiV0PingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundPingAgentsManagementApiV0PlaygroundPingPost(playgroundPingRequest: PlaygroundPingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaygroundPingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundPingAgentsManagementApiV0PlaygroundPingPost(playgroundPingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundPingAgentsManagementApiV0PlaygroundPingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundPingCopilotsManagementApiV0PlaygroundPingPost(playgroundPingRequest: PlaygroundPingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaygroundPingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundPingCopilotsManagementApiV0PlaygroundPingPost(playgroundPingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundPingCopilotsManagementApiV0PlaygroundPingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentExecutionApi - factory interface
 * @export
 */
export const AgentExecutionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentExecutionApiFp(configuration)
    return {
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(requestParameters: AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
         * @summary Cancel Session
         * @param {AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(requestParameters: AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionResponse> {
            return localVarFp.getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(axios, basePath));
        },
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCopilotsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionResponse> {
            return localVarFp.getSessionCopilotsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentAgentsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.invokeAgentAgentsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentCopilotsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.invokeAgentCopilotsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(requestParameters: AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionMessagesResponse> {
            return localVarFp.listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(requestParameters.sessionId, requestParameters.pageSize, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
         * @summary List Session Messages
         * @param {AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(requestParameters: AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionMessagesResponse> {
            return localVarFp.listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(requestParameters.sessionId, requestParameters.pageSize, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(requestParameters: AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentHistoryResponse> {
            return localVarFp.listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(requestParameters.agentId, requestParameters.environment, requestParameters.from, requestParameters.to, requestParameters.pageSize, requestParameters.sortField, requestParameters.sortDirection, requestParameters.cursor, requestParameters.status, requestParameters.agentVersionId, requestParameters.origin, requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
         * @summary List Sessions
         * @param {AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(requestParameters: AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentHistoryResponse> {
            return localVarFp.listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(requestParameters.agentId, requestParameters.environment, requestParameters.from, requestParameters.to, requestParameters.pageSize, requestParameters.sortField, requestParameters.sortDirection, requestParameters.cursor, requestParameters.status, requestParameters.agentVersionId, requestParameters.origin, requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {AgentExecutionApiPingAgentsManagementApiV0PingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingAgentsManagementApiV0PingPost(requestParameters: AgentExecutionApiPingAgentsManagementApiV0PingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.pingAgentsManagementApiV0PingPost(requestParameters.pingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
         * @summary Ping
         * @param {AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingCopilotsManagementApiV0PingPost(requestParameters: AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.pingCopilotsManagementApiV0PingPost(requestParameters.pingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlaygroundPingResponse> {
            return localVarFp.playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingCopilotsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlaygroundPingResponse> {
            return localVarFp.playgroundPingCopilotsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest
 */
export interface AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost
     */
    readonly sessionId: string
}

/**
 * Request parameters for cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest
 */
export interface AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost
     */
    readonly sessionId: string
}

/**
 * Request parameters for getSessionAgentsManagementApiV0SessionsSessionIdGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest
 */
export interface AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {boolean}
     * @memberof AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGet
     */
    readonly includeMessages?: boolean
}

/**
 * Request parameters for getSessionCopilotsManagementApiV0SessionsSessionIdGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest
 */
export interface AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {boolean}
     * @memberof AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGet
     */
    readonly includeMessages?: boolean
}

/**
 * Request parameters for invokeAgentAgentsManagementApiV0InvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest
 */
export interface AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest {
    /**
     * 
     * @type {Data}
     * @memberof AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePost
     */
    readonly data: Data
}

/**
 * Request parameters for invokeAgentCopilotsManagementApiV0InvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest
 */
export interface AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest {
    /**
     * 
     * @type {Data}
     * @memberof AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePost
     */
    readonly data: Data
}

/**
 * Request parameters for listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest
 */
export interface AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {number}
     * @memberof AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly cursor?: string | null
}

/**
 * Request parameters for listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest
 */
export interface AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {number}
     * @memberof AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet
     */
    readonly cursor?: string | null
}

/**
 * Request parameters for listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest
 */
export interface AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly agentId: string

    /**
     * 
     * @type {Environment}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly environment: Environment

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly from: string

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly to: string

    /**
     * 
     * @type {number}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly pageSize: number

    /**
     * 
     * @type {SortField}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly sortField: SortField

    /**
     * 
     * @type {SortDirection}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly sortDirection: SortDirection

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly cursor?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly agentVersionId?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly origin?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly model?: string | null
}

/**
 * Request parameters for listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest
 */
export interface AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly agentId: string

    /**
     * 
     * @type {Environment}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly environment: Environment

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly from: string

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly to: string

    /**
     * 
     * @type {number}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly pageSize: number

    /**
     * 
     * @type {SortField}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly sortField: SortField

    /**
     * 
     * @type {SortDirection}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly sortDirection: SortDirection

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly cursor?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly agentVersionId?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly origin?: string | null

    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet
     */
    readonly model?: string | null
}

/**
 * Request parameters for pingAgentsManagementApiV0PingPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPingAgentsManagementApiV0PingPostRequest
 */
export interface AgentExecutionApiPingAgentsManagementApiV0PingPostRequest {
    /**
     * 
     * @type {PingRequest}
     * @memberof AgentExecutionApiPingAgentsManagementApiV0PingPost
     */
    readonly pingRequest: PingRequest
}

/**
 * Request parameters for pingCopilotsManagementApiV0PingPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest
 */
export interface AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest {
    /**
     * 
     * @type {PingRequest}
     * @memberof AgentExecutionApiPingCopilotsManagementApiV0PingPost
     */
    readonly pingRequest: PingRequest
}

/**
 * Request parameters for playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest
 */
export interface AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest {
    /**
     * 
     * @type {AgentPlaygroundInvokeRequest}
     * @memberof AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost
     */
    readonly agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest
}

/**
 * Request parameters for playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest
 */
export interface AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest {
    /**
     * 
     * @type {AgentPlaygroundInvokeRequest}
     * @memberof AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost
     */
    readonly agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest
}

/**
 * Request parameters for playgroundPingAgentsManagementApiV0PlaygroundPingPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest
 */
export interface AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest {
    /**
     * 
     * @type {PlaygroundPingRequest}
     * @memberof AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPost
     */
    readonly playgroundPingRequest: PlaygroundPingRequest
}

/**
 * Request parameters for playgroundPingCopilotsManagementApiV0PlaygroundPingPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest
 */
export interface AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest {
    /**
     * 
     * @type {PlaygroundPingRequest}
     * @memberof AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPost
     */
    readonly playgroundPingRequest: PlaygroundPingRequest
}

/**
 * AgentExecutionApi - object-oriented interface
 * @export
 * @class AgentExecutionApi
 * @extends {BaseAPI}
 */
export class AgentExecutionApi extends BaseAPI {
    /**
     * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
     * @summary Cancel Session
     * @param {AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(requestParameters: AgentExecutionApiCancelSessionAgentsManagementApiV0SessionsSessionIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).cancelSessionAgentsManagementApiV0SessionsSessionIdCancelPost(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel an in-flight agent session.  Marks the session CANCELLED via a conditional write, then emits terminal metrics + analytics, then runs best-effort cleanup of in-flight flow tools and the parent-flow callback. Returns:  - 204 on first transition or already-CANCELLED. - 404 if the session does not exist. - 409 if the session is already terminal as SUCCESS / FAILED.
     * @summary Cancel Session
     * @param {AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(requestParameters: AgentExecutionApiCancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).cancelSessionCopilotsManagementApiV0SessionsSessionIdCancelPost(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
     * @summary Get Session
     * @param {AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
     * @summary Get Session
     * @param {AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public getSessionCopilotsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionCopilotsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).getSessionCopilotsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
     * @summary Invoke Agent
     * @param {AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public invokeAgentAgentsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).invokeAgentAgentsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
     * @summary Invoke Agent
     * @param {AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public invokeAgentCopilotsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentCopilotsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).invokeAgentCopilotsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
     * @summary List Session Messages
     * @param {AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(requestParameters: AgentExecutionApiListSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).listSessionMessagesAgentsManagementApiV0SessionsSessionIdMessagesGet(requestParameters.sessionId, requestParameters.pageSize, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated message list for a session.  Returns all message types. HumanMessages are stripped to just the user-typed text (invocation_message), without formatted structured_input.
     * @summary List Session Messages
     * @param {AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(requestParameters: AgentExecutionApiListSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).listSessionMessagesCopilotsManagementApiV0SessionsSessionIdMessagesGet(requestParameters.sessionId, requestParameters.pageSize, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
     * @summary List Sessions
     * @param {AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(requestParameters: AgentExecutionApiListSessionsAgentsManagementApiV0AgentsAgentIdSessionsGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).listSessionsAgentsManagementApiV0AgentsAgentIdSessionsGet(requestParameters.agentId, requestParameters.environment, requestParameters.from, requestParameters.to, requestParameters.pageSize, requestParameters.sortField, requestParameters.sortDirection, requestParameters.cursor, requestParameters.status, requestParameters.agentVersionId, requestParameters.origin, requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List sessions for an agent with filtering, sorting, and aggregate metrics.  Returns paginated sessions (without messages or config), aggregate metrics computed over all filtered results, and total count.  Uses cursor-based pagination: pass the `next_cursor` from a previous response to fetch the next page.
     * @summary List Sessions
     * @param {AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(requestParameters: AgentExecutionApiListSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).listSessionsCopilotsManagementApiV0AgentsAgentIdSessionsGet(requestParameters.agentId, requestParameters.environment, requestParameters.from, requestParameters.to, requestParameters.pageSize, requestParameters.sortField, requestParameters.sortDirection, requestParameters.cursor, requestParameters.status, requestParameters.agentVersionId, requestParameters.origin, requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
     * @summary Ping
     * @param {AgentExecutionApiPingAgentsManagementApiV0PingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public pingAgentsManagementApiV0PingPost(requestParameters: AgentExecutionApiPingAgentsManagementApiV0PingPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).pingAgentsManagementApiV0PingPost(requestParameters.pingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-warm an AgentCore container for an upcoming live agent invocation.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session. Uses the caller-provided ``session_id`` as the AgentCore ``runtimeSessionId`` so the subsequent ``/invoke`` with the same ``session_id`` lands on the warmed container.
     * @summary Ping
     * @param {AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public pingCopilotsManagementApiV0PingPost(requestParameters: AgentExecutionApiPingCopilotsManagementApiV0PingPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).pingCopilotsManagementApiV0PingPost(requestParameters.pingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
     * @summary Playground Invoke Agent
     * @param {AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
     * @summary Playground Invoke Agent
     * @param {AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundInvokeAgentCopilotsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
     * @summary Playground Ping
     * @param {AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
     * @summary Playground Ping
     * @param {AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundPingCopilotsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingCopilotsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundPingCopilotsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentManagementApi - axios parameter creator
 * @export
 */
export const AgentManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAgentsManagementApiV0AgentsPost: async (agentCreate: AgentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreate' is not null or undefined
            assertParamExists('createAgentAgentsManagementApiV0AgentsPost', 'agentCreate', agentCreate)
            const localVarPath = `/agents/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentCopilotsManagementApiV0AgentsPost: async (agentCreate: AgentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreate' is not null or undefined
            assertParamExists('createAgentCopilotsManagementApiV0AgentsPost', 'agentCreate', agentCreate)
            const localVarPath = `/copilots/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost: async (agentId: string, agentVersionCreate: AgentVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost', 'agentId', agentId)
            // verify required parameter 'agentVersionCreate' is not null or undefined
            assertParamExists('createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost', 'agentVersionCreate', agentVersionCreate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost: async (agentId: string, agentVersionCreate: AgentVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost', 'agentId', agentId)
            // verify required parameter 'agentVersionCreate' is not null or undefined
            assertParamExists('createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost', 'agentVersionCreate', agentVersionCreate)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAgentsManagementApiV0AgentsAgentIdDelete: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgentAgentsManagementApiV0AgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'versionId', versionId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'versionId', versionId)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentAgentsManagementApiV0AgentsAgentIdGet: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentAgentsManagementApiV0AgentsAgentIdGet', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCopilotsManagementApiV0AgentsAgentIdGet: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentCopilotsManagementApiV0AgentsAgentIdGet', 'agentId', agentId)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {string} flowSlug 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet: async (flowSlug: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet', 'flowSlug', flowSlug)
            const localVarPath = `/agents/management/api/v0/depending_on/flow/{flow_slug}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {string} flowSlug 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet: async (flowSlug: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet', 'flowSlug', flowSlug)
            const localVarPath = `/copilots/management/api/v0/depending_on/flow/{flow_slug}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet: async (flowSlug: string, flowVersionId: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/agents/management/api/v0/depending_on/flow/{flow_slug}/version/{flow_version_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet: async (flowSlug: string, flowVersionId: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/copilots/management/api/v0/depending_on/flow/{flow_slug}/version/{flow_version_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'versionId', versionId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'versionId', versionId)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsAgentsManagementApiV0AgentsGet: async (folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agents/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsCopilotsManagementApiV0AgentsGet: async (folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/copilots/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableModelsAgentsManagementApiV0ModelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agents/management/api/v0/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableModelsCopilotsManagementApiV0ModelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/copilots/management/api/v0/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet: async (agentId: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet: async (agentId: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet', 'agentId', agentId)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost: async (agentId: string, versionId: string, ifMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'ifMatch', ifMatch)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}/publish`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost: async (agentId: string, versionId: string, ifMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'ifMatch', ifMatch)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions/{version_id}/publish`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentAgentsManagementApiV0AgentsAgentIdPut: async (agentId: string, agentUpdate: AgentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentAgentsManagementApiV0AgentsAgentIdPut', 'agentId', agentId)
            // verify required parameter 'agentUpdate' is not null or undefined
            assertParamExists('updateAgentAgentsManagementApiV0AgentsAgentIdPut', 'agentUpdate', agentUpdate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCopilotsManagementApiV0AgentsAgentIdPut: async (agentId: string, agentUpdate: AgentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentCopilotsManagementApiV0AgentsAgentIdPut', 'agentId', agentId)
            // verify required parameter 'agentUpdate' is not null or undefined
            assertParamExists('updateAgentCopilotsManagementApiV0AgentsAgentIdPut', 'agentUpdate', agentUpdate)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {string} agentId 
         * @param {AgentPrebuiltConfigurationPatch} agentPrebuiltConfigurationPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch: async (agentId: string, agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch', 'agentId', agentId)
            // verify required parameter 'agentPrebuiltConfigurationPatch' is not null or undefined
            assertParamExists('updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch', 'agentPrebuiltConfigurationPatch', agentPrebuiltConfigurationPatch)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/prebuilt-configuration`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPrebuiltConfigurationPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {string} agentId 
         * @param {AgentPrebuiltConfigurationPatch} agentPrebuiltConfigurationPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch: async (agentId: string, agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch', 'agentId', agentId)
            // verify required parameter 'agentPrebuiltConfigurationPatch' is not null or undefined
            assertParamExists('updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch', 'agentPrebuiltConfigurationPatch', agentPrebuiltConfigurationPatch)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/prebuilt-configuration`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPrebuiltConfigurationPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut: async (agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'ifMatch', ifMatch)
            // verify required parameter 'agentVersionUpdate' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentVersionUpdate', agentVersionUpdate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut: async (agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'ifMatch', ifMatch)
            // verify required parameter 'agentVersionUpdate' is not null or undefined
            assertParamExists('updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentVersionUpdate', agentVersionUpdate)
            const localVarPath = `/copilots/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentManagementApi - functional programming interface
 * @export
 */
export const AgentManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentAgentsManagementApiV0AgentsPost(agentCreate: AgentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentAgentsManagementApiV0AgentsPost(agentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createAgentAgentsManagementApiV0AgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentCopilotsManagementApiV0AgentsPost(agentCreate: AgentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentCopilotsManagementApiV0AgentsPost(agentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createAgentCopilotsManagementApiV0AgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(agentId: string, agentVersionCreate: AgentVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(agentId, agentVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(agentId: string, agentVersionCreate: AgentVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(agentId, agentVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentAgentsManagementApiV0AgentsAgentIdGet(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentAgentsManagementApiV0AgentsAgentIdGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentAgentsManagementApiV0AgentsAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentCopilotsManagementApiV0AgentsAgentIdGet(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentCopilotsManagementApiV0AgentsAgentIdGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentCopilotsManagementApiV0AgentsAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {string} flowSlug 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(flowSlug: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionsDependingOnFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(flowSlug, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {string} flowSlug 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(flowSlug: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionsDependingOnFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(flowSlug, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(flowSlug: string, flowVersionId: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionsDependingOnFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(flowSlug, flowVersionId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(flowSlug: string, flowVersionId: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionsDependingOnFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(flowSlug, flowVersionId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentsAgentsManagementApiV0AgentsGet(folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentsAgentsManagementApiV0AgentsGet(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listAgentsAgentsManagementApiV0AgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentsCopilotsManagementApiV0AgentsGet(folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentsCopilotsManagementApiV0AgentsGet(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listAgentsCopilotsManagementApiV0AgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableModelsAgentsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableModelsAgentsManagementApiV0ModelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listAvailableModelsAgentsManagementApiV0ModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableModelsCopilotsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableModelsCopilotsManagementApiV0ModelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listAvailableModelsCopilotsManagementApiV0ModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(agentId: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(agentId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(agentId: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(agentId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId: string, versionId: string, ifMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId, versionId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId: string, versionId: string, ifMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId, versionId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentAgentsManagementApiV0AgentsAgentIdPut(agentId: string, agentUpdate: AgentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentAgentsManagementApiV0AgentsAgentIdPut(agentId, agentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateAgentAgentsManagementApiV0AgentsAgentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentCopilotsManagementApiV0AgentsAgentIdPut(agentId: string, agentUpdate: AgentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentCopilotsManagementApiV0AgentsAgentIdPut(agentId, agentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateAgentCopilotsManagementApiV0AgentsAgentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {string} agentId 
         * @param {AgentPrebuiltConfigurationPatch} agentPrebuiltConfigurationPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(agentId: string, agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(agentId, agentPrebuiltConfigurationPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {string} agentId 
         * @param {AgentPrebuiltConfigurationPatch} agentPrebuiltConfigurationPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(agentId: string, agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(agentId, agentPrebuiltConfigurationPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId, versionId, ifMatch, agentVersionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId, versionId, ifMatch, agentVersionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentManagementApi - factory interface
 * @export
 */
export const AgentManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentManagementApiFp(configuration)
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAgentsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentCreateResponse> {
            return localVarFp.createAgentAgentsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentCopilotsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentCreateResponse> {
            return localVarFp.createAgentCopilotsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
         * @summary Delete Agent
         * @param {AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
         * @summary Delete Version
         * @param {AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentGetResponse> {
            return localVarFp.getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an agent by ID.  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCopilotsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentGetResponse> {
            return localVarFp.getAgentCopilotsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionsDependingOnFlowResponse> {
            return localVarFp.getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters.flowSlug, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Find agent versions that depend on a given flow via flow tools.
         * @summary Get Agents Depending On Flow
         * @param {AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionsDependingOnFlowResponse> {
            return localVarFp.getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters.flowSlug, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionsDependingOnFlowResponse> {
            return localVarFp.getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Find agent versions that depend on a specific flow version via flow tools.
         * @summary Get Agents Depending On Flow Version
         * @param {AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionsDependingOnFlowResponse> {
            return localVarFp.getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsAgentsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AgentListResponse> {
            return localVarFp.listAgentsAgentsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsCopilotsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AgentListResponse> {
            return localVarFp.listAgentsCopilotsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableModelsAgentsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig): AxiosPromise<AvailableModelsResponse> {
            return localVarFp.listAvailableModelsAgentsManagementApiV0ModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
         * @summary List Available Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableModelsCopilotsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig): AxiosPromise<AvailableModelsResponse> {
            return localVarFp.listAvailableModelsCopilotsManagementApiV0ModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionListResponse> {
            return localVarFp.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionListResponse> {
            return localVarFp.listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
         * @summary Publish Version
         * @param {AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentUpdateResponse> {
            return localVarFp.updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent
         * @param {AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCopilotsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentUpdateResponse> {
            return localVarFp.updateAgentCopilotsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters: AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentUpdateResponse> {
            return localVarFp.updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters.agentId, requestParameters.agentPrebuiltConfigurationPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
         * @summary Update Agent Prebuilt Configuration
         * @param {AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters: AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentUpdateResponse> {
            return localVarFp.updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters.agentId, requestParameters.agentPrebuiltConfigurationPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAgentAgentsManagementApiV0AgentsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest
 */
export interface AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest {
    /**
     * 
     * @type {AgentCreate}
     * @memberof AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPost
     */
    readonly agentCreate: AgentCreate
}

/**
 * Request parameters for createAgentCopilotsManagementApiV0AgentsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest
 */
export interface AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest {
    /**
     * 
     * @type {AgentCreate}
     * @memberof AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPost
     */
    readonly agentCreate: AgentCreate
}

/**
 * Request parameters for createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest
 */
export interface AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionCreate}
     * @memberof AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentVersionCreate: AgentVersionCreate
}

/**
 * Request parameters for createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest
 */
export interface AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionCreate}
     * @memberof AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentVersionCreate: AgentVersionCreate
}

/**
 * Request parameters for deleteAgentAgentsManagementApiV0AgentsAgentIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest
 */
export interface AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDelete
     */
    readonly agentId: string
}

/**
 * Request parameters for deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest
 */
export interface AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDelete
     */
    readonly agentId: string
}

/**
 * Request parameters for deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest
 */
export interface AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly versionId: string
}

/**
 * Request parameters for deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest
 */
export interface AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly versionId: string
}

/**
 * Request parameters for getAgentAgentsManagementApiV0AgentsAgentIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest
 */
export interface AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGet
     */
    readonly agentId: string
}

/**
 * Request parameters for getAgentCopilotsManagementApiV0AgentsAgentIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest
 */
export interface AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGet
     */
    readonly agentId: string
}

/**
 * Request parameters for getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest
 */
export interface AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest
 */
export interface AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest
 */
export interface AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly flowVersionId: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest
 */
export interface AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly flowVersionId: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest
 */
export interface AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly versionId: string
}

/**
 * Request parameters for getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest
 */
export interface AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly versionId: string
}

/**
 * Request parameters for listAgentsAgentsManagementApiV0AgentsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest
 */
export interface AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListAgentsAgentsManagementApiV0AgentsGet
     */
    readonly folderId?: string | null
}

/**
 * Request parameters for listAgentsCopilotsManagementApiV0AgentsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest
 */
export interface AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGet
     */
    readonly folderId?: string | null
}

/**
 * Request parameters for listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest
 */
export interface AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest
 */
export interface AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest
 */
export interface AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly ifMatch: string
}

/**
 * Request parameters for publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest
 */
export interface AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly ifMatch: string
}

/**
 * Request parameters for updateAgentAgentsManagementApiV0AgentsAgentIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest
 */
export interface AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentUpdate}
     * @memberof AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPut
     */
    readonly agentUpdate: AgentUpdate
}

/**
 * Request parameters for updateAgentCopilotsManagementApiV0AgentsAgentIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest
 */
export interface AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentUpdate}
     * @memberof AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPut
     */
    readonly agentUpdate: AgentUpdate
}

/**
 * Request parameters for updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest
 */
export interface AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentPrebuiltConfigurationPatch}
     * @memberof AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch
     */
    readonly agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch
}

/**
 * Request parameters for updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest
 */
export interface AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentPrebuiltConfigurationPatch}
     * @memberof AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch
     */
    readonly agentPrebuiltConfigurationPatch: AgentPrebuiltConfigurationPatch
}

/**
 * Request parameters for updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest
 */
export interface AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly ifMatch: string

    /**
     * 
     * @type {AgentVersionUpdate}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentVersionUpdate: AgentVersionUpdate
}

/**
 * Request parameters for updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest
 */
export interface AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly ifMatch: string

    /**
     * 
     * @type {AgentVersionUpdate}
     * @memberof AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentVersionUpdate: AgentVersionUpdate
}

/**
 * AgentManagementApi - object-oriented interface
 * @export
 * @class AgentManagementApi
 * @extends {BaseAPI}
 */
export class AgentManagementApi extends BaseAPI {
    /**
     * Create a new agent.  Raises:     409: If an agent with the slug already exists
     * @summary Create Agent
     * @param {AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createAgentAgentsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createAgentAgentsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new agent.  Raises:     409: If an agent with the slug already exists
     * @summary Create Agent
     * @param {AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createAgentCopilotsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentCopilotsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createAgentCopilotsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
     * @summary Create Version
     * @param {AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, source version, or credential is not found     409: If a version with the same name already exists
     * @summary Create Version
     * @param {AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionCopilotsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createVersionCopilotsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
     * @summary Delete Agent
     * @param {AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete an agent.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent is not found     409: If the agent has published versions
     * @summary Delete Agent
     * @param {AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentCopilotsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteAgentCopilotsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
     * @summary Delete Version
     * @param {AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete an agent version.  Raises:     403: If prebuilt and caller lacks `d:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is published and referenced by flows
     * @summary Delete Version
     * @param {AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an agent by ID.  Raises:     404: If the agent is not found
     * @summary Get Agent
     * @param {AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an agent by ID.  Raises:     404: If the agent is not found
     * @summary Get Agent
     * @param {AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentCopilotsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentCopilotsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentCopilotsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find agent versions that depend on a given flow via flow tools.
     * @summary Get Agents Depending On Flow
     * @param {AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentsDependingOnFlowAgentsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters.flowSlug, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find agent versions that depend on a given flow via flow tools.
     * @summary Get Agents Depending On Flow
     * @param {AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentsDependingOnFlowCopilotsManagementApiV0DependingOnFlowFlowSlugGet(requestParameters.flowSlug, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find agent versions that depend on a specific flow version via flow tools.
     * @summary Get Agents Depending On Flow Version
     * @param {AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentsDependingOnFlowVersionAgentsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find agent versions that depend on a specific flow version via flow tools.
     * @summary Get Agents Depending On Flow Version
     * @param {AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters: AgentManagementApiGetAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentsDependingOnFlowVersionCopilotsManagementApiV0DependingOnFlowFlowSlugVersionFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific agent version.  Raises:     404: If the agent or version is not found
     * @summary Get Version
     * @param {AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific agent version.  Raises:     404: If the agent or version is not found
     * @summary Get Version
     * @param {AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List agents, optionally filtered by folder.
     * @summary List Agents
     * @param {AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listAgentsAgentsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listAgentsAgentsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List agents, optionally filtered by folder.
     * @summary List Agents
     * @param {AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listAgentsCopilotsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsCopilotsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listAgentsCopilotsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
     * @summary List Available Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listAvailableModelsAgentsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listAvailableModelsAgentsManagementApiV0ModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List models available for agent configuration.  Returns models filtered by regional availability for this workspace, plus BYOK entries from workspace credentials.
     * @summary List Available Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listAvailableModelsCopilotsManagementApiV0ModelsGet(options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listAvailableModelsCopilotsManagementApiV0ModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List versions for an agent.
     * @summary List Versions
     * @param {AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List versions for an agent.
     * @summary List Versions
     * @param {AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listVersionsCopilotsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
     * @summary Publish Version
     * @param {AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish a draft version.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match     422: If flow tools reference unpublished flow versions
     * @summary Publish Version
     * @param {AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).publishVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
     * @summary Update Agent
     * @param {AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent\'s metadata.  Raises:     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
     * @summary Update Agent
     * @param {AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateAgentCopilotsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentCopilotsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateAgentCopilotsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
     * @summary Update Agent Prebuilt Configuration
     * @param {AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters: AgentManagementApiUpdateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateAgentPrebuiltConfigurationAgentsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters.agentId, requestParameters.agentPrebuiltConfigurationPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or clear the agent\'s ``prebuilt_configuration`` field.  Raises:     403: If the caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent is not found
     * @summary Update Agent Prebuilt Configuration
     * @param {AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters: AgentManagementApiUpdateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatchRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateAgentPrebuiltConfigurationCopilotsManagementApiV0AgentsAgentIdPrebuiltConfigurationPatch(requestParameters.agentId, requestParameters.agentPrebuiltConfigurationPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
     * @summary Update Version
     * @param {AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     400: If the selected model is not supported or not available in the region     403: If prebuilt and caller lacks `w:workspace_prebuilt_agent_management`     404: If the agent, version, or credential is not found     409: If the version is already published or name already exists     412: If etag does not match
     * @summary Update Version
     * @param {AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateVersionCopilotsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CredentialsApi - axios parameter creator
 * @export
 */
export const CredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Credential
         * @param {ModelProvider} provider 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentialAgentsManagementApiV0SettingsCredentialsPost: async (provider: ModelProvider, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('createCredentialAgentsManagementApiV0SettingsCredentialsPost', 'provider', provider)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createCredentialAgentsManagementApiV0SettingsCredentialsPost', 'requestBody', requestBody)
            const localVarPath = `/agents/management/api/v0/settings/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Credential By Id
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete: async (credentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete', 'credentialId', credentialId)
            const localVarPath = `/agents/management/api/v0/settings/credentials/{credential_id}`
                .replace(`{${"credential_id"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentialsAgentsManagementApiV0SettingsCredentialsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agents/management/api/v0/settings/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run Connectivity Test
         * @param {string} credentialId 
         * @param {Environment} [environment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost: async (credentialId: string, environment?: Environment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost', 'credentialId', credentialId)
            const localVarPath = `/agents/management/api/v0/settings/credentials/{credential_id}/test`
                .replace(`{${"credential_id"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Credential By Id
         * @param {string} credentialId 
         * @param {CredentialUpdateRequest} credentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut: async (credentialId: string, credentialUpdateRequest: CredentialUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut', 'credentialId', credentialId)
            // verify required parameter 'credentialUpdateRequest' is not null or undefined
            assertParamExists('updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut', 'credentialUpdateRequest', credentialUpdateRequest)
            const localVarPath = `/agents/management/api/v0/settings/credentials/{credential_id}`
                .replace(`{${"credential_id"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(credentialUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CredentialsApi - functional programming interface
 * @export
 */
export const CredentialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CredentialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Credential
         * @param {ModelProvider} provider 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCredentialAgentsManagementApiV0SettingsCredentialsPost(provider: ModelProvider, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCredentialAgentsManagementApiV0SettingsCredentialsPost(provider, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.createCredentialAgentsManagementApiV0SettingsCredentialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Credential By Id
         * @param {string} credentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(credentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(credentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.listCredentialsAgentsManagementApiV0SettingsCredentialsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run Connectivity Test
         * @param {string} credentialId 
         * @param {Environment} [environment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(credentialId: string, environment?: Environment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(credentialId, environment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Credential By Id
         * @param {string} credentialId 
         * @param {CredentialUpdateRequest} credentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(credentialId: string, credentialUpdateRequest: CredentialUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(credentialId, credentialUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CredentialsApi - factory interface
 * @export
 */
export const CredentialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CredentialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Credential
         * @param {CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredentialAgentsManagementApiV0SettingsCredentialsPost(requestParameters: CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CredentialItem> {
            return localVarFp.createCredentialAgentsManagementApiV0SettingsCredentialsPost(requestParameters.provider, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Credential By Id
         * @param {CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(requestParameters: CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(requestParameters.credentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options?: RawAxiosRequestConfig): AxiosPromise<CredentialListResponse> {
            return localVarFp.listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run Connectivity Test
         * @param {CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(requestParameters: CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CredentialTestResult> {
            return localVarFp.runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(requestParameters.credentialId, requestParameters.environment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Credential By Id
         * @param {CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(requestParameters: CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CredentialItem> {
            return localVarFp.updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(requestParameters.credentialId, requestParameters.credentialUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCredentialAgentsManagementApiV0SettingsCredentialsPost operation in CredentialsApi.
 * @export
 * @interface CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest
 */
export interface CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest {
    /**
     * 
     * @type {ModelProvider}
     * @memberof CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPost
     */
    readonly provider: ModelProvider

    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPost
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete operation in CredentialsApi.
 * @export
 * @interface CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest
 */
export interface CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete
     */
    readonly credentialId: string
}

/**
 * Request parameters for runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost operation in CredentialsApi.
 * @export
 * @interface CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest
 */
export interface CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost
     */
    readonly credentialId: string

    /**
     * 
     * @type {Environment}
     * @memberof CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost
     */
    readonly environment?: Environment
}

/**
 * Request parameters for updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut operation in CredentialsApi.
 * @export
 * @interface CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest
 */
export interface CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut
     */
    readonly credentialId: string

    /**
     * 
     * @type {CredentialUpdateRequest}
     * @memberof CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut
     */
    readonly credentialUpdateRequest: CredentialUpdateRequest
}

/**
 * CredentialsApi - object-oriented interface
 * @export
 * @class CredentialsApi
 * @extends {BaseAPI}
 */
export class CredentialsApi extends BaseAPI {
    /**
     * 
     * @summary Create Credential
     * @param {CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public createCredentialAgentsManagementApiV0SettingsCredentialsPost(requestParameters: CredentialsApiCreateCredentialAgentsManagementApiV0SettingsCredentialsPostRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).createCredentialAgentsManagementApiV0SettingsCredentialsPost(requestParameters.provider, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Credential By Id
     * @param {CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(requestParameters: CredentialsApiDeleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).deleteCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdDelete(requestParameters.credentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listCredentialsAgentsManagementApiV0SettingsCredentialsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run Connectivity Test
     * @param {CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(requestParameters: CredentialsApiRunConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPostRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).runConnectivityTestAgentsManagementApiV0SettingsCredentialsCredentialIdTestPost(requestParameters.credentialId, requestParameters.environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Credential By Id
     * @param {CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(requestParameters: CredentialsApiUpdateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPutRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).updateCredentialByIdAgentsManagementApiV0SettingsCredentialsCredentialIdPut(requestParameters.credentialId, requestParameters.credentialUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



